import { An as e, At as t, Ct as n, En as r, Et as i, Ht as a, Jn as o, Ln as s, Ot as c, Qt as l, Rn as u, Tt as d, V as f, Xt as p, Zt as m, an as h, cn as g, dn as _, f as ee, gn as v, gt as te, hn as y, in as b, kt as x, mn as S, nn as ne, on as re, pn as ie, pt as ae, rn as oe, t as se, tn as ce, vn as C, vt as le, wt as ue } from "./blocks-CU0VONcw.js";
import { C as de, D as fe, E as pe, O as me, S as he, T as ge, _ as _e, d as ve, f as ye, k as be, l as xe, m as Se, n as Ce, o as we, p as Te, t as Ee, u as De, v as Oe, w as ke, x as Ae, y as w } from "./extensions-ClbwUxGa.js";
import { r as je, t as Me } from "./BlockNoteExtension-B6RhuQ3V.js";
import { t as Ne } from "./ShowSelection-BsHFfdMi.js";
import { t as Pe } from "./en-CiZEVExl.js";
import { t as Fe } from "./EventEmitter-CuPnGDYt.js";
import { DOMParser as Ie, DOMSerializer as Le, Fragment as T, Node as Re, NodeRange as ze, Slice as E } from "prosemirror-model";
import { ReplaceAroundStep as D, ReplaceStep as Be, canJoin as Ve, liftTarget as He } from "prosemirror-transform";
import { Editor as Ue, Extension as O, Mark as k, Node as A, combineTransactionSteps as We, createDocument as Ge, extensions as j, findChildrenInRange as Ke, findParentNodeClosestToPos as qe, getAttributes as Je, getChangedRanges as Ye, getMarkRange as Xe, getMarksBetween as Ze, getSchema as Qe, isNodeSelection as $e, markPasteRule as et, mergeAttributes as tt, posToDOMRect as nt, selectionToInsertionEnd as rt } from "@tiptap/core";
import { NodeSelection as M, Plugin as N, TextSelection as P } from "prosemirror-state";
import { Fragment as F, Slice as it } from "@tiptap/pm/model";
import { CellSelection as I, TableMap as at } from "prosemirror-tables";
import { Plugin as L, PluginKey as R } from "@tiptap/pm/state";
import { InputRule as ot, inputRules as st } from "@handlewithcare/prosemirror-inputrules";
import { keymap as ct } from "@tiptap/pm/keymap";
import { Gapcursor as lt } from "@tiptap/extensions/gap-cursor";
import { Text as ut } from "@tiptap/extension-text";
//#region src/schema/inlineContent/createSpec.ts
function dt(e, t) {
	let n = [{
		tag: `[data-inline-content-type="${e.type}"]`,
		contentElement: (e) => {
			let t = e;
			return t.matches("[data-editable]") ? t : t.querySelector("[data-editable]") || t;
		}
	}];
	return t && n.push({
		tag: "*",
		getAttrs(e) {
			if (typeof e == "string") return !1;
			let n = t?.(e);
			return n === void 0 ? !1 : n;
		}
	}), n;
}
function ft(e, t) {
	return l(A.create({
		name: e.type,
		inline: !0,
		group: "inline",
		draggable: t.meta?.draggable,
		selectable: e.content === "styled",
		atom: e.content === "none",
		content: e.content === "styled" ? "inline*" : "",
		addAttributes() {
			return r(e.propSchema);
		},
		addKeyboardShortcuts() {
			return m(e);
		},
		parseHTML() {
			return dt(e, t.parse);
		},
		renderHTML({ node: n }) {
			let r = this.options.editor;
			return p(t.render.call({
				renderType: "dom",
				props: void 0
			}, h(n, r.schema.inlineContentSchema, r.schema.styleSchema), () => {}, r), e.type, n.attrs, e.propSchema);
		},
		addNodeView() {
			return (n) => {
				let { node: r, getPos: i } = n, a = this.options.editor;
				return p(t.render.call({
					renderType: "nodeView",
					props: n
				}, h(r, a.schema.inlineContentSchema, a.schema.styleSchema), (e) => {
					let t = x([e], a.pmSchema), n = i();
					n && a.transact((e) => e.replaceWith(n, n + r.nodeSize, t));
				}, a), e.type, r.attrs, e.propSchema);
			};
		}
	}), e.propSchema, {
		...t,
		toExternalHTML: t.toExternalHTML,
		render(n, r, i) {
			return p(t.render(n, r, i), e.type, n.props, e.propSchema);
		}
	});
}
//#endregion
//#region src/api/blockManipulation/commands/insertBlocks/insertBlocks.ts
function pt(e, t, n, r = "before") {
	let a = typeof n == "string" ? n : n.id, o = _(e), s = t.map((e) => {
		let t = c(e, o);
		return t.check(), t;
	}), l = i(a, e.doc);
	if (!l) throw Error(`Block with ID ${a} not found`);
	let u = l.posBeforeNode;
	return r === "after" && (u += l.node.nodeSize), e.step(new Be(u, u, new E(T.from(s), 0, 0))), s.map((e) => b(e, o));
}
//#endregion
//#region src/api/blockManipulation/commands/replaceBlocks/util/fixColumnList.ts
function z(e) {
	if (!e || e.type.name !== "column") throw Error("Invalid columnPos: does not point to column node.");
	let t = e.firstChild;
	if (!t) throw Error("Invalid column: does not have child node.");
	let n = t.firstChild;
	if (!n) throw Error("Invalid blockContainer: does not have child node.");
	return e.childCount === 1 && t.childCount === 1 && n.type.name === "paragraph" && n.content.content.length === 0;
}
function mt(e, t) {
	let n = e.doc.resolve(t), r = n.nodeAfter;
	if (!r || r.type.name !== "columnList") throw Error("Invalid columnListPos: does not point to columnList node.");
	for (let t = r.childCount - 1; t >= 0; t--) {
		let r = e.doc.resolve(n.pos + 1).posAtIndex(t), i = e.doc.resolve(r).nodeAfter;
		if (!i || i.type.name !== "column") throw Error("Invalid columnPos: does not point to column node.");
		z(i) && e.delete(r, r + i.nodeSize);
	}
}
function B(e, t) {
	mt(e, t);
	let n = e.doc.resolve(t).nodeAfter;
	if (!n || n.type.name !== "columnList") throw Error("Invalid columnListPos: does not point to columnList node.");
	if (n.childCount > 2) return;
	if (n.childCount < 2) throw Error("Invalid columnList: contains fewer than two children.");
	let r = t + 1, i = e.doc.resolve(r).nodeAfter, a = t + n.nodeSize - 1, o = e.doc.resolve(a).nodeBefore;
	if (!i || !o) throw Error("Invalid columnList: does not contain children.");
	let s = z(i), c = z(o);
	if (s && c) {
		e.delete(t, t + n.nodeSize);
		return;
	}
	if (s) {
		e.step(new D(t, t + n.nodeSize, a - o.nodeSize + 1, a - 1, E.empty, 0, !1));
		return;
	}
	if (c) {
		e.step(new D(t, t + n.nodeSize, r + 1, r + i.nodeSize - 1, E.empty, 0, !1));
		return;
	}
}
//#endregion
//#region src/api/blockManipulation/commands/replaceBlocks/replaceBlocks.ts
function V(e, t, n) {
	let r = _(e), i = n.map((e) => {
		let t = c(e, r);
		return t.check(), t;
	}), a = new Set(t.map((e) => typeof e == "string" ? e : e.id)), o = [], s = /* @__PURE__ */ new Set(), l = typeof t[0] == "string" ? t[0] : t[0].id, u = 0;
	if (e.doc.descendants((t, c) => {
		if (a.size === 0) return !1;
		if (!t.type.isInGroup("bnBlock") || !a.has(t.attrs.id)) return !0;
		if (o.push(b(t, r)), a.delete(t.attrs.id), n.length > 0 && t.attrs.id === l) {
			let t = e.doc.nodeSize;
			e.insert(c, i);
			let n = e.doc.nodeSize;
			u += t - n;
		}
		let d = e.doc.nodeSize, f = e.doc.resolve(c - u);
		f.node().type.name === "column" ? s.add(f.before(-1)) : f.node().type.name === "columnList" && s.add(f.before()), f.node().type.name === "blockGroup" && f.node(f.depth - 1).type.name !== "doc" && f.node().childCount === 1 ? e.delete(f.before(), f.after()) : e.delete(c - u, c - u + t.nodeSize);
		let p = e.doc.nodeSize;
		return u += d - p, !1;
	}), a.size > 0) {
		let e = [...a].join("\n");
		throw Error("Blocks with the following IDs could not be found in the editor: " + e);
	}
	return s.forEach((t) => B(e, t)), {
		insertedBlocks: i.map((e) => b(e, r)),
		removedBlocks: o
	};
}
//#endregion
//#region src/api/exporters/html/util/serializeBlocksInternalHTML.ts
function ht(e, n, r, i, a) {
	let o;
	if (!n) throw Error("blockContent is required");
	if (typeof n == "string") o = x([n], e.pmSchema, i);
	else if (Array.isArray(n)) o = x(n, e.pmSchema, i);
	else if (n.type === "tableContent") o = t(n, e.pmSchema);
	else throw new u(n.type);
	let s = (a?.document ?? document).createDocumentFragment();
	for (let t of o) if (t.type.name !== "text" && e.schema.inlineContentSchema[t.type.name]) {
		let n = e.schema.inlineContentSpecs[t.type.name].implementation;
		if (n) {
			let i = h(t, e.schema.inlineContentSchema, e.schema.styleSchema), o = n.render.call({
				renderType: "dom",
				props: void 0
			}, i, () => {}, e);
			if (o) {
				if (s.appendChild(o.dom), o.contentDOM) {
					let e = r.serializeFragment(t.content, a);
					o.contentDOM.dataset.editable = "", o.contentDOM.appendChild(e);
				}
				continue;
			}
		}
	} else if (t.type.name === "text") {
		let n = document.createTextNode(t.textContent);
		for (let r of t.marks.toReversed()) if (r.type.name in e.schema.styleSpecs) {
			let t = e.schema.styleSpecs[r.type.name].implementation.render(r.attrs.stringValue, e);
			t.contentDOM.appendChild(n), n = t.dom;
		} else {
			let e = r.type.spec.toDOM(r, !0), t = Le.renderSpec(document, e);
			t.contentDOM.appendChild(n), n = t.dom;
		}
		s.appendChild(n);
	} else {
		let e = r.serializeFragment(T.from([t]), a);
		s.appendChild(e);
	}
	return s;
}
function gt(e, t, n, r) {
	let i = e.pmSchema.nodes.blockContainer, a = t.props || {};
	for (let [n, r] of Object.entries(e.schema.blockSchema[t.type].propSchema)) !(n in a) && r.default !== void 0 && (a[n] = r.default);
	let o = t.children || [], s = e.blockImplementations[t.type].implementation.render.call({
		renderType: "dom",
		props: void 0
	}, {
		...t,
		props: a,
		children: o
	}, e);
	if (s.contentDOM && t.content) {
		let i = ht(e, t.content, n, t.type, r);
		s.contentDOM.appendChild(i);
	}
	if (e.pmSchema.nodes[t.type].isInGroup("bnBlock")) {
		if (t.children && t.children.length > 0) {
			let i = _t(e, t.children, n, r);
			s.contentDOM?.append(i);
		}
		return s.dom;
	}
	let c = i.spec?.toDOM?.(i.create({
		id: t.id,
		...a
	}));
	return c.contentDOM?.appendChild(s.dom), t.children && t.children.length > 0 && c.contentDOM?.appendChild(vt(e, t.children, n, r)), c.dom;
}
function _t(e, t, n, r) {
	let i = (r?.document ?? document).createDocumentFragment();
	for (let a of t) {
		let t = gt(e, a, n, r);
		i.appendChild(t);
	}
	return i;
}
var vt = (e, t, n, r) => {
	let i = e.pmSchema.nodes.blockGroup, a = i.spec.toDOM(i.create({})), o = _t(e, t, n, r);
	return a.contentDOM?.appendChild(o), a.dom;
}, yt = (e) => (e.querySelectorAll("[data-content-type=\"numberedListItem\"]").forEach((e) => {
	let t = e.closest(".bn-block-outer")?.previousElementSibling?.querySelector("[data-content-type=\"numberedListItem\"]");
	if (!t) e.setAttribute("data-index", e.getAttribute("data-start") || "1");
	else {
		let n = t.getAttribute("data-index");
		e.setAttribute("data-index", (parseInt(n || "0") + 1).toString());
	}
}), e), bt = (e) => (e.querySelectorAll("[data-content-type=\"checkListItem\"] input").forEach((e) => {
	e.disabled = !0;
}), e), xt = (e) => (e.querySelectorAll(".bn-toggle-wrapper[data-show-children=\"false\"]").forEach((e) => {
	e.setAttribute("data-show-children", "true");
}), e), St = (e) => (e.querySelectorAll("[data-content-type=\"table\"] table").forEach((e) => {
	e.setAttribute("style", "--default-cell-min-width: 120px;"), e.setAttribute("data-show-children", "true");
}), e), Ct = (e) => (e.querySelectorAll("[data-content-type=\"table\"] table").forEach((e) => {
	let t = document.createElement("div");
	t.className = "tableWrapper";
	let n = document.createElement("div");
	n.className = "tableWrapper-inner", t.appendChild(n), e.parentElement?.appendChild(t), t.appendChild(e);
}), e), wt = (e) => (e.querySelectorAll(".bn-inline-content:empty").forEach((e) => {
	let t = document.createElement("span");
	t.className = "ProseMirror-trailingBreak", t.setAttribute("style", "display: inline-block;"), e.appendChild(t);
}), e), Tt = (e, t) => {
	let n = Le.fromSchema(e), r = [
		yt,
		bt,
		xt,
		St,
		Ct,
		wt
	];
	return { serializeBlocks: (e, i) => {
		let a = vt(t, e, n, i);
		for (let e of r) a = e(a);
		return a.outerHTML;
	} };
};
//#endregion
//#region src/api/blockManipulation/commands/moveBlocks/moveBlocks.ts
function Et(e) {
	return e.transact((e) => {
		let t = C(e.doc, e.selection.anchor);
		if (e.selection instanceof I) return {
			type: "cell",
			anchorBlockId: t.node.attrs.id,
			anchorCellOffset: e.selection.$anchorCell.pos - t.posBeforeNode,
			headCellOffset: e.selection.$headCell.pos - t.posBeforeNode
		};
		if (e.selection instanceof M) return {
			type: "node",
			anchorBlockId: t.node.attrs.id
		};
		{
			let n = C(e.doc, e.selection.head);
			return {
				type: "text",
				anchorBlockId: t.node.attrs.id,
				headBlockId: n.node.attrs.id,
				anchorOffset: e.selection.anchor - t.posBeforeNode,
				headOffset: e.selection.head - n.posBeforeNode
			};
		}
	});
}
function Dt(e, t) {
	let n = i(t.anchorBlockId, e.doc)?.posBeforeNode;
	if (n === void 0) throw Error(`Could not find block with ID ${t.anchorBlockId} to update selection`);
	let r;
	if (t.type === "cell") r = I.create(e.doc, n + t.anchorCellOffset, n + t.headCellOffset);
	else if (t.type === "node") r = M.create(e.doc, n + 1);
	else {
		let a = i(t.headBlockId, e.doc)?.posBeforeNode;
		if (a === void 0) throw Error(`Could not find block with ID ${t.headBlockId} to update selection`);
		r = P.create(e.doc, n + t.anchorOffset, a + t.headOffset);
	}
	e.setSelection(r);
}
function H(e) {
	return e.map((e) => e.type === "columnList" ? e.children.map((e) => H(e.children)).flat() : {
		...e,
		children: H(e.children)
	}).flat();
}
function Ot(e, t, n) {
	e.transact((r) => {
		let i = e.getSelection()?.blocks || [e.getTextCursorPosition().block], a = Et(e);
		e.removeBlocks(i), e.insertBlocks(H(i), t, n), Dt(r, a);
	});
}
function kt(e) {
	return !e || e.type !== "columnList";
}
function At(e, t, n) {
	let r, i;
	if (t ? t.children.length > 0 ? (r = t.children[t.children.length - 1], i = "after") : (r = t, i = "before") : n && (r = n, i = "before"), !r || !i) return;
	let a = e.getParentBlock(r);
	return kt(a) ? {
		referenceBlock: r,
		placement: i
	} : At(e, i === "after" ? r : e.getPrevBlock(r), a);
}
function jt(e, t, n) {
	let r, i;
	if (t ? t.children.length > 0 ? (r = t.children[0], i = "before") : (r = t, i = "after") : n && (r = n, i = "after"), !r || !i) return;
	let a = e.getParentBlock(r);
	return kt(a) ? {
		referenceBlock: r,
		placement: i
	} : jt(e, i === "before" ? r : e.getNextBlock(r), a);
}
function Mt(e) {
	e.transact(() => {
		let t = e.getSelection()?.blocks[0] || e.getTextCursorPosition().block, n = At(e, e.getPrevBlock(t), e.getParentBlock(t));
		n && Ot(e, n.referenceBlock, n.placement);
	});
}
function Nt(e) {
	e.transact(() => {
		let t = e.getSelection(), n = t?.blocks[t?.blocks.length - 1] || e.getTextCursorPosition().block, r = jt(e, e.getNextBlock(n), e.getParentBlock(n));
		r && Ot(e, r.referenceBlock, r.placement);
	});
}
//#endregion
//#region src/api/blockManipulation/commands/nestBlock/nestBlock.ts
function Pt(e, t, n) {
	let { $from: r, $to: i } = e.selection, a = r.blockRange(i, (e) => e.childCount > 0 && (e.type.name === "blockGroup" || e.type.name === "column"));
	if (!a) return !1;
	let o = a.startIndex;
	if (o === 0) return !1;
	let s = a.parent.child(o - 1);
	if (s.type !== t) return !1;
	let c = s.lastChild && s.lastChild.type === n, l = T.from(c ? t.create() : null), u = new E(T.from(t.create(null, T.from(n.create(null, l)))), c ? 3 : 1, 0), d = a.start, f = a.end;
	return e.step(new D(d - (c ? 3 : 1), f, d, f, u, 1, !0)).scrollIntoView(), !0;
}
function Ft(e) {
	return e.transact((t) => Pt(t, e.pmSchema.nodes.blockContainer, e.pmSchema.nodes.blockGroup));
}
function It(e, t, n, r) {
	let i = r.end, a = r.$to.end(r.depth);
	if (i < a) {
		let o = r.parent.child(r.endIndex - 1), s = o.lastChild && o.lastChild.type === n;
		e.step(new D(i - (s ? 2 : 1), a, i, a, new E(T.from(t.create(null, n.create())), s ? 2 : 1, 0), +!s, !0)), r = new ze(e.doc.resolve(r.$from.pos), e.doc.resolve(a), r.depth);
	}
	let o = He(r);
	if (o == null) return !1;
	e.lift(r, o);
	let s = e.doc.resolve(e.mapping.map(i, -1) - 1);
	return Ve(e.doc, s.pos) && s.nodeBefore.type === s.nodeAfter.type && e.join(s.pos), e.scrollIntoView(), !0;
}
function U(e, t, n) {
	let { $from: r, $to: i } = e.selection, a = r.blockRange(i, (e) => e.childCount > 0 && (e.type.name === "blockGroup" || e.type.name === "column"));
	return a && r.node(a.depth - 1).type === t ? It(e, t, n, a) : !1;
}
function Lt(e) {
	return e.transact((t) => U(t, e.pmSchema.nodes.blockContainer, e.pmSchema.nodes.blockGroup));
}
function Rt(e) {
	return e.transact((e) => {
		let { bnBlock: t } = v(e);
		return e.doc.resolve(t.beforePos).nodeBefore !== null;
	});
}
function zt(e) {
	return e.transact((e) => {
		let { bnBlock: t } = v(e);
		return e.doc.resolve(t.beforePos).depth > 1;
	});
}
//#endregion
//#region src/api/blockManipulation/getBlock/getBlock.ts
function Bt(e, t) {
	let n = typeof t == "string" ? t : t.id, r = _(e), a = i(n, e);
	if (a) return b(a.node, r);
}
function Vt(e, t) {
	let n = i(typeof t == "string" ? t : t.id, e), r = _(e);
	if (!n) return;
	let a = e.resolve(n.posBeforeNode).nodeBefore;
	if (a) return b(a, r);
}
function Ht(e, t) {
	let n = i(typeof t == "string" ? t : t.id, e), r = _(e);
	if (!n) return;
	let a = e.resolve(n.posBeforeNode + n.node.nodeSize).nodeAfter;
	if (a) return b(a, r);
}
function Ut(e, t) {
	let n = typeof t == "string" ? t : t.id, r = _(e), a = i(n, e);
	if (!a) return;
	let o = e.resolve(a.posBeforeNode), s = o.node(), c = o.node(-1), l = c.type.name === "doc" ? void 0 : s.type.name === "blockGroup" ? c : s;
	if (l) return b(l, r);
}
//#endregion
//#region src/editor/managers/BlockManager.ts
var Wt = class {
	constructor(e) {
		this.editor = e;
	}
	get document() {
		return this.editor.transact((e) => oe(e.doc, this.editor.pmSchema));
	}
	getBlock(e) {
		return this.editor.transact((t) => Bt(t.doc, e));
	}
	getPrevBlock(e) {
		return this.editor.transact((t) => Vt(t.doc, e));
	}
	getNextBlock(e) {
		return this.editor.transact((t) => Ht(t.doc, e));
	}
	getParentBlock(e) {
		return this.editor.transact((t) => Ut(t.doc, e));
	}
	forEachBlock(e, t = !1) {
		let n = this.document.slice();
		t && n.reverse();
		function r(n) {
			for (let i of n) if (e(i) === !1 || !r(t ? i.children.slice().reverse() : i.children)) return !1;
			return !0;
		}
		r(n);
	}
	insertBlocks(e, t, n = "before") {
		return this.editor.transact((r) => pt(r, e, t, n));
	}
	updateBlock(e, t) {
		return this.editor.transact((r) => n(r, e, t));
	}
	removeBlocks(e) {
		return this.editor.transact((t) => V(t, e, []).removedBlocks);
	}
	replaceBlocks(e, t) {
		return this.editor.transact((n) => V(n, e, t));
	}
	canNestBlock() {
		return Rt(this.editor);
	}
	nestBlock() {
		Ft(this.editor);
	}
	canUnnestBlock() {
		return zt(this.editor);
	}
	unnestBlock() {
		Lt(this.editor);
	}
	moveBlocksUp() {
		return Mt(this.editor);
	}
	moveBlocksDown() {
		return Nt(this.editor);
	}
}, Gt = class extends Fe {
	constructor(e) {
		super(), this.editor = e, e.on("create", () => {
			e._tiptapEditor.on("update", ({ transaction: t, appendedTransactions: n }) => {
				this.emit("onChange", {
					editor: e,
					transaction: t,
					appendedTransactions: n
				});
			}), e._tiptapEditor.on("selectionUpdate", ({ transaction: t }) => {
				this.emit("onSelectionChange", {
					editor: e,
					transaction: t
				});
			}), e._tiptapEditor.on("mount", () => {
				this.emit("onMount", { editor: e });
			}), e._tiptapEditor.on("unmount", () => {
				this.emit("onUnmount", { editor: e });
			});
		});
	}
	onChange(e, t = !0) {
		let n = ({ transaction: n, appendedTransactions: r }) => {
			!t && Kt(n) || e(this.editor, { getChanges() {
				return me(n, r);
			} });
		};
		return this.on("onChange", n), () => {
			this.off("onChange", n);
		};
	}
	onSelectionChange(e, t = !1) {
		let n = (n) => {
			!t && Kt(n.transaction) || e(this.editor);
		};
		return this.on("onSelectionChange", n), () => {
			this.off("onSelectionChange", n);
		};
	}
	onMount(e) {
		return this.on("onMount", e), () => {
			this.off("onMount", e);
		};
	}
	onUnmount(e) {
		return this.on("onUnmount", e), () => {
			this.off("onUnmount", e);
		};
	}
};
function Kt(e) {
	return !!e.getMeta("y-sync$");
}
//#endregion
//#region src/api/parsers/html/util/nestedLists.ts
function qt(e) {
	return Array.prototype.indexOf.call(e.parentElement.childNodes, e);
}
function Jt(e) {
	return e.nodeType === 3 && !/\S/.test(e.nodeValue || "");
}
function Yt(e) {
	e.querySelectorAll("li > ul, li > ol").forEach((e) => {
		let t = qt(e), n = e.parentElement, r = Array.from(n.childNodes).slice(t + 1);
		e.remove(), r.forEach((e) => {
			e.remove();
		}), n.insertAdjacentElement("afterend", e), r.reverse().forEach((t) => {
			if (Jt(t)) return;
			let n = document.createElement("li");
			n.append(t), e.insertAdjacentElement("afterend", n);
		}), n.childNodes.length === 0 && n.remove();
	});
}
function Xt(e) {
	e.querySelectorAll("li + ul, li + ol").forEach((e) => {
		let t = e.previousElementSibling, n = document.createElement("div");
		t.insertAdjacentElement("afterend", n), n.append(t);
		let r = document.createElement("div");
		for (r.setAttribute("data-node-type", "blockGroup"), n.append(r); n.nextElementSibling?.nodeName === "UL" || n.nextElementSibling?.nodeName === "OL";) r.append(n.nextElementSibling);
	});
}
var Zt = null;
function Qt() {
	return Zt ||= document.implementation.createHTMLDocument("title");
}
function $t(e) {
	if (typeof e == "string") {
		let t = Qt().createElement("div");
		t.innerHTML = e, e = t;
	}
	return Yt(e), Xt(e), e;
}
//#endregion
//#region src/api/parsers/html/util/normalizeWhitespace.ts
function en(e) {
	let t = e.ownerDocument.createTreeWalker(e, 128), n;
	for (; n = t.nextNode();) if (/^\s*notionvc:/.test(n.nodeValue || "")) return !0;
	return !1;
}
function tn(e) {
	let t = new Set(["PRE", "CODE"]), n = e.ownerDocument.createTreeWalker(e, 4, { acceptNode(n) {
		let r = n.parentElement;
		for (; r && r !== e;) {
			if (t.has(r.tagName)) return 2;
			r = r.parentElement;
		}
		return 1;
	} }), r = [], i;
	for (; i = n.nextNode();) r.push(i);
	for (let e of r) e.nodeValue && /[\r\n]/.test(e.nodeValue) && (e.nodeValue = e.nodeValue.replace(/[ \t\r\n\f]+/g, " "));
}
function nn(e) {
	en(e) || tn(e);
}
//#endregion
//#region src/api/parsers/html/parseHTML.ts
function W(e, t) {
	let n = $t(e);
	nn(n);
	let r = Ie.fromSchema(t).parse(n, { topNode: t.nodes.blockGroup.create() }), i = [];
	for (let e = 0; e < r.childCount; e++) i.push(b(r.child(e), t));
	return i;
}
//#endregion
//#region src/api/parsers/markdown/markdownToHtml.ts
function G(e) {
	return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function rn(e) {
	return e ? /\w/.test(e) : !1;
}
function K(e, t, n) {
	let r = t > 0 ? e[t - 1] : void 0, i = t + n < e.length ? e[t + n] : void 0;
	return rn(r) && rn(i);
}
function an(e, t) {
	if (e[t] !== "\\" || t + 1 >= e.length) return null;
	let n = e[t + 1];
	return n === "\n" ? {
		html: "<br>\n",
		end: t + 2
	} : "\\`*_{}[]()#+-.!~|>".includes(n) ? {
		html: G(n),
		end: t + 2
	} : null;
}
function on(e, t) {
	return e[t] === "`" ? Sn(e, t) : null;
}
function sn(e, t) {
	return e[t] !== "!" || e[t + 1] !== "[" ? null : Cn(e, t);
}
function cn(e, t) {
	return e[t] === "[" ? wn(e, t) : null;
}
function ln(e, t) {
	return e[t] !== "~" || e[t + 1] !== "~" ? null : J(e, t, "~~", "<del>", "</del>");
}
function un(e, t) {
	return e[t] === "*" && e[t + 1] === "*" && e[t + 2] === "*" || e[t] === "_" && e[t + 1] === "_" && e[t + 2] === "_" && !K(e, t, 3) ? J(e, t, e.substring(t, t + 3), "<strong><em>", "</em></strong>") : null;
}
function dn(e, t) {
	return e[t] === "*" && e[t + 1] === "*" || e[t] === "_" && e[t + 1] === "_" && !K(e, t, 2) ? J(e, t, e.substring(t, t + 2), "<strong>", "</strong>") : null;
}
function fn(e, t) {
	return e[t] === "*" || e[t] === "_" && !K(e, t, 1) ? J(e, t, e[t], "<em>", "</em>") : null;
}
function pn(e, t) {
	return e[t] === "\n" ? {
		html: "<br>\n",
		end: t + 1
	} : null;
}
var mn = /^<\/?[a-zA-Z][a-zA-Z0-9-]*(?:\s+[a-zA-Z_:][a-zA-Z0-9_.:-]*(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'=<>`]+))?)*\s*\/?>/, hn = /^<!--[\s\S]*?-->/, gn = /^<!\[CDATA\[[\s\S]*?\]\]>/, _n = /^<\?[\s\S]*?\?>/, vn = /^<![A-Za-z][\s\S]*?>/;
function yn(e, t) {
	if (e[t] !== "<") return null;
	let n = e.substring(t);
	for (let e of [
		hn,
		gn,
		_n,
		vn,
		mn
	]) {
		let r = n.match(e);
		if (r) return {
			html: r[0],
			end: t + r[0].length
		};
	}
	return null;
}
var bn = /* @__PURE__ */ new Set("\\`![~*_\n<"), xn = [
	an,
	on,
	sn,
	cn,
	ln,
	un,
	dn,
	fn,
	yn,
	pn
];
function q(e) {
	let t = "", n = 0;
	for (; n < e.length;) {
		if (e[n] === "\n" && n >= 2 && e[n - 1] === " " && e[n - 2] === " ") {
			t = t.replace(/ +$/, ""), t += "<br>\n", n++;
			continue;
		}
		let r = !1;
		if (bn.has(e[n])) for (let i of xn) {
			let a = i(e, n);
			if (a) {
				t += a.html, n = a.end, r = !0;
				break;
			}
		}
		if (!r) {
			let r = n;
			for (n++; n < e.length && !bn.has(e[n]);) n++;
			t += G(e.substring(r, n));
		}
	}
	return t;
}
function Sn(e, t) {
	let n = 0, r = t;
	for (; r < e.length && e[r] === "`";) n++, r++;
	let i = r;
	for (; i < e.length;) if (e[i] === "`") {
		let t = 0, a = i;
		for (; i < e.length && e[i] === "`";) t++, i++;
		if (t === n) {
			let t = e.substring(r, a);
			return t = t.replace(/\n/g, " "), t.length >= 2 && t[0] === " " && t[t.length - 1] === " " && /[^ ]/.test(t) && (t = t.substring(1, t.length - 1)), {
				html: `<code>${G(t)}</code>`,
				end: i
			};
		}
	} else i++;
	return null;
}
function Cn(t, n) {
	let r = Tn(t, n + 1);
	if (r === -1) return null;
	let i = n + 2;
	if (t[r + 1] !== "(") return null;
	let a = r + 2, o = En(t, a - 1);
	if (o === -1) return null;
	let s = t.substring(i, r), { url: c, title: l } = Dn(t.substring(a, o));
	if (e(c)) {
		let e = s || l;
		return {
			html: `<video src="${G(c)}"${e ? ` data-name="${G(e)}"` : ""} data-url="${G(c)}" controls></video>`,
			end: o + 1
		};
	}
	let u = l === void 0 ? "" : ` title="${G(l)}"`;
	return {
		html: `<img src="${G(c)}" alt="${G(s)}"${u}>`,
		end: o + 1
	};
}
function wn(e, t) {
	let n = t + 1, r = Tn(e, t);
	if (r === -1 || e[r + 1] !== "(") return null;
	let i = r + 2, a = En(e, r + 1);
	if (a === -1) return null;
	let o = e.substring(n, r), { url: s, title: c } = Dn(e.substring(i, a)), l = c === void 0 ? "" : ` title="${G(c)}"`;
	return {
		html: `<a href="${G(s)}"${l}>${q(o)}</a>`,
		end: a + 1
	};
}
function Tn(e, t) {
	let n = 0;
	for (let r = t; r < e.length; r++) {
		if (e[r] === "\\" && r + 1 < e.length) {
			r++;
			continue;
		}
		if (e[r] === "[" && n++, e[r] === "]" && (n--, n === 0)) return r;
	}
	return -1;
}
function En(e, t) {
	let n = 0;
	for (let r = t; r < e.length; r++) {
		if (e[r] === "\\" && r + 1 < e.length) {
			r++;
			continue;
		}
		if (e[r] === "(" && n++, e[r] === ")" && (n--, n === 0)) return r;
	}
	return -1;
}
function Dn(e) {
	e = e.trim();
	let t, n;
	if (e.startsWith("<")) {
		let r = e.indexOf(">");
		r === -1 ? (t = e.substring(1), n = "") : (t = e.substring(1, r), n = e.substring(r + 1).trim());
	} else {
		let r = e.length;
		for (let t = 0; t < e.length; t++) {
			if (e[t] === "\\" && t + 1 < e.length) {
				t++;
				continue;
			}
			if (e[t] === " " || e[t] === "	" || e[t] === "\n") {
				r = t;
				break;
			}
		}
		t = e.substring(0, r), n = e.substring(r).trim();
	}
	let r;
	if (n.length > 0) {
		let e = n.match(/^"([^"]*)"$|^'([^']*)'$|^\(([^)]*)\)$/);
		e && (r = e[1] ?? e[2] ?? e[3]);
	}
	return {
		url: t,
		title: r
	};
}
function J(e, t, n, r, i) {
	let a = n.length, o = t + a;
	if (o >= e.length || e[o] === " " || e[o] === "	") return null;
	let s = o;
	for (; s < e.length;) {
		if (e[s] === "\\" && s + 1 < e.length) {
			s += 2;
			continue;
		}
		if (e.substring(s, s + a) === n) {
			if (e[s - 1] === " " || e[s - 1] === "	") {
				s++;
				continue;
			}
			if (a === 1 && (s > 0 && e[s - 1] === n[0] && !(s >= 2 && e[s - 2] === "\\") || s + a < e.length && e[s + a] === n[0])) {
				s++;
				continue;
			}
			let t = e.substring(o, s);
			if (t.length === 0) {
				s++;
				continue;
			}
			return {
				html: r + q(t) + i,
				end: s + a
			};
		}
		s++;
	}
	return null;
}
var On = new Set(/* @__PURE__ */ "address.article.aside.audio.base.basefont.blockquote.body.caption.center.col.colgroup.dd.details.dialog.dir.div.dl.dt.fieldset.figcaption.figure.footer.form.frame.frameset.h1.h2.h3.h4.h5.h6.head.header.hr.html.iframe.legend.li.link.main.menu.menuitem.nav.noframes.ol.optgroup.option.p.param.section.source.summary.table.tbody.td.tfoot.th.thead.title.tr.track.ul".split("."));
function kn(e) {
	if (/^ {0,3}<(!--|\?|![A-Za-z]|!\[CDATA\[)/.test(e)) return !0;
	let t = e.match(/^ {0,3}<\/?([a-zA-Z][a-zA-Z0-9-]*)(?:\s|\/?>|$)/);
	return t ? On.has(t[1].toLowerCase()) : !1;
}
function Y(e) {
	let t = e.split("\n"), n = [], r = 0, i = !0;
	for (; r < t.length;) {
		let e = t[r];
		if (e.trim() === "") {
			i = !0, r++;
			continue;
		}
		let a = e.match(/^ {0,3}(`{3,}|~{3,})(.*)$/);
		if (a) {
			let e = a[1], o = e[0], s = e.length, c = a[2].trim(), l = [];
			for (r++; r < t.length;) {
				if (t[r].match(RegExp(`^ {0,3}${o}{${s},}\\s*$`))) {
					r++;
					break;
				}
				l.push(t[r]), r++;
			}
			n.push({
				type: "codeBlock",
				language: c || "",
				code: l.join("\n")
			}), i = !1;
			continue;
		}
		let o = e.match(/^(#{1,6})\s+(.+?)(?:\s+#+\s*|\s*)$/);
		if (o) {
			n.push({
				type: "heading",
				level: o[1].length,
				content: o[2]
			}), i = !1, r++;
			continue;
		}
		if (/^(\s{0,3})([-*_])\s*(\2\s*){2,}$/.test(e)) {
			let t = n[n.length - 1];
			if (!i && e.trim().match(/^-+$/) && t && t.type === "paragraph") {
				let e = t;
				n[n.length - 1] = {
					type: "heading",
					level: 2,
					content: e.content
				}, i = !1, r++;
				continue;
			}
			n.push({ type: "hr" }), i = !1, r++;
			continue;
		}
		if (r + 1 < t.length) {
			let a = t[r + 1];
			if (/^={1,}\s*$/.test(a) && e.trim().length > 0) {
				n.push({
					type: "heading",
					level: 1,
					content: e.trim()
				}), i = !1, r += 2;
				continue;
			}
		}
		let s = An(t, r);
		if (s) {
			n.push(s.token), r = s.nextLine, i = !1;
			continue;
		}
		if (/^\s{0,3}>/.test(e)) {
			let e = [];
			for (; r < t.length && /^\s{0,3}>/.test(t[r]);) e.push(t[r].replace(/^\s{0,3}>\s?/, "")), r++;
			for (; r < t.length;) {
				let n = t[r];
				if (n.trim() === "" || /^\s{0,3}>/.test(n) || /^(#{1,6})\s/.test(n) || /^(`{3,}|~{3,})/.test(n) || /^(\s{0,3})([-*_])\s*(\2\s*){2,}$/.test(n) || /^\s*([-*+]|\d+[.)])\s+/.test(n) || /^\s*\|(.+\|)+\s*$/.test(n)) break;
				e.push(n), r++;
			}
			n.push({
				type: "blockquote",
				content: e.join("\n")
			}), i = !1;
			continue;
		}
		let c = e.match(/^(\s*)([-*+]|\d+[.)])(\s+)(\[[ xX]\] )?(.*)$/);
		if (c) {
			let e = c[1].length, a = c[2], o = c[3], s = c[4], l = c[5], u, d, f;
			s ? (u = "task", f = s.trim() !== "[ ]") : /^\d+[.)]$/.test(a) ? (u = "ordered", d = parseInt(a, 10)) : u = "bullet";
			let p = e + a.length + o.length + (s ? s.length : 0), m = e + 1, h = (e) => {
				if (e.trim() === "") return !0;
				let t = e.match(/^\s*/)[0].length;
				return !!(t >= p || t >= m && e.match(/^\s*([-*+]|\d+[.)])\s+/));
			};
			r++;
			let g = [];
			for (; r < t.length;) {
				let e = t[r];
				if (e.trim() === "") {
					let e = r + 1;
					for (; e < t.length && t[e].trim() === "";) e++;
					if (e < t.length && h(t[e])) {
						g.push(""), r++;
						continue;
					}
					break;
				}
				if (!h(e)) break;
				e.match(/^\s*/)[0].length >= p ? g.push(e.substring(p)) : g.push(e.substring(m)), r++;
			}
			let _ = g.join("\n").replace(/^\n+|\n+$/g, "");
			n.push({
				type: "listItem",
				listType: u,
				indent: e,
				content: l.trim(),
				start: d,
				checked: f,
				childContent: _ || void 0
			}), i = !1;
			continue;
		}
		if (kn(e)) {
			let e = [];
			for (; r < t.length && t[r].trim() !== "";) e.push(t[r]), r++;
			n.push({
				type: "rawHtml",
				content: e.join("\n")
			}), i = !1;
			continue;
		}
		let l = [e];
		for (r++; r < t.length;) {
			let e = t[r];
			if (e.trim() === "" || /^(#{1,6})\s/.test(e) || /^(`{3,}|~{3,})/.test(e) || /^\s{0,3}>/.test(e) || /^(\s{0,3})([-*_])\s*(\2\s*){2,}$/.test(e) || /^\s*([-*+]|\d+[.)])\s+/.test(e) || /^\s*\|(.+\|)+\s*$/.test(e) || kn(e) || r + 1 < t.length && /^[=-]+\s*$/.test(t[r + 1]) && e.trim().length > 0) break;
			l.push(e), r++;
		}
		n.push({
			type: "paragraph",
			content: l.map((e) => e.replace(/^ {1,3}/, "")).join("\n").replace(/[ \t]+$/, "")
		}), i = !1;
	}
	return n;
}
function An(e, t) {
	if (t + 1 >= e.length) return null;
	let n = e[t], r = e[t + 1];
	if (!r.includes("|") || !/^\s*\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)*\|?\s*$/.test(r) || !n.includes("|")) return null;
	let i = jn(n), a = Mn(r), o = [], s = t + 2;
	for (; s < e.length;) {
		let t = e[s];
		if (!t.includes("|")) break;
		o.push(jn(t)), s++;
	}
	return {
		token: {
			type: "table",
			headers: i,
			rows: o,
			alignments: a
		},
		nextLine: s
	};
}
function jn(e) {
	let t = e.trim(), n = t.startsWith("|") ? t.substring(1) : t, r = n.endsWith("|") ? n.substring(0, n.length - 1) : n, i = [], a = "";
	for (let e = 0; e < r.length; e++) r[e] === "\\" && e + 1 < r.length && r[e + 1] === "|" ? (a += "|", e++) : r[e] === "|" ? (i.push(a.trim()), a = "") : a += r[e];
	return i.push(a.trim()), i;
}
function Mn(e) {
	return jn(e).map((e) => {
		let t = e.trim(), n = t.startsWith(":"), r = t.endsWith(":");
		return n && r ? "center" : r ? "right" : n ? "left" : null;
	});
}
function Nn(e) {
	let t = "", n = 0;
	for (; n < e.length;) {
		let r = e[n];
		switch (r.type) {
			case "heading": {
				let e = r;
				t += `<h${e.level}>${q(e.content)}</h${e.level}>`, n++;
				break;
			}
			case "paragraph":
				t += `<p>${q(r.content)}</p>`, n++;
				break;
			case "codeBlock": {
				let e = r, i = e.language ? ` data-language="${G(e.language)}"` : "";
				t += `<pre><code${i}>${G(e.code)}</code></pre>`, n++;
				break;
			}
			case "blockquote": {
				let e = Nn(Y(r.content));
				t += `<blockquote>${e}</blockquote>`, n++;
				break;
			}
			case "hr":
				t += "<hr>", n++;
				break;
			case "listItem": {
				let r = Pn(e, n);
				t += r.html, n = r.nextIndex;
				break;
			}
			case "table":
				t += In(r), n++;
				break;
			case "rawHtml":
				t += r.content, n++;
				break;
			default: n++;
		}
	}
	return t;
}
function Pn(e, t) {
	let n = "", r = t, i = null;
	for (; r < e.length && e[r].type === "listItem";) {
		let t = e[r], a = Fn(t.listType);
		if (i !== null && i !== a && (n += `</${i === "ordered" ? "ol" : "ul"}>`, i = null), i === null) {
			if (a === "ordered") {
				let e = t.start !== void 0 && t.start !== 1 ? ` start="${t.start}"` : "";
				n += `<ol${e}>`;
			} else n += "<ul>";
			i = a;
		}
		if (t.listType === "task") {
			let e = t.checked ? " checked" : "";
			n += `<li><input type="checkbox" disabled${e}><p>${q(t.content)}</p>`;
		} else n += `<li><p>${q(t.content)}</p>`;
		if (t.childContent) {
			let e = Y(t.childContent);
			n += Nn(e);
		}
		n += "</li>", r++;
	}
	return i !== null && (n += `</${i === "ordered" ? "ol" : "ul"}>`), {
		html: n,
		nextIndex: r
	};
}
function Fn(e) {
	return e === "ordered" ? "ordered" : "bullet";
}
function In(e) {
	let t = "<table>", n = e.headers.every((e) => e.trim() === ""), r = e.headers.length;
	if (!n) {
		t += "<thead><tr>";
		for (let n = 0; n < r; n++) {
			let r = e.alignments[n], i = r ? ` align="${r}"` : "";
			t += `<th${i}>${q(e.headers[n])}</th>`;
		}
		t += "</tr></thead>";
	}
	if (e.rows.length > 0) {
		t += "<tbody>";
		for (let n of e.rows) {
			t += "<tr>";
			for (let i = 0; i < r; i++) {
				let r = i < n.length ? n[i] : "", a = e.alignments[i], o = a ? ` align="${a}"` : "";
				t += `<td${o}>${q(r)}</td>`;
			}
			t += "</tr>";
		}
		t += "</tbody>";
	}
	return t += "</table>", t;
}
function Ln(e) {
	return Nn(Y(e));
}
//#endregion
//#region src/api/parsers/markdown/parseMarkdown.ts
function Rn(e) {
	return Ln(e);
}
function zn(e, t) {
	return W(Rn(e), t);
}
//#endregion
//#region src/editor/managers/ExportManager.ts
var Bn = class {
	constructor(e) {
		this.editor = e;
	}
	blocksToHTMLLossy(e = this.editor.document) {
		return be(this.editor.pmSchema, this.editor).exportBlocks(e, {});
	}
	blocksToFullHTML(e = this.editor.document) {
		return Tt(this.editor.pmSchema, this.editor).serializeBlocks(e, {});
	}
	tryParseHTMLToBlocks(e) {
		return W(e, this.editor.pmSchema);
	}
	blocksToMarkdownLossy(e = this.editor.document) {
		return De(e, this.editor.pmSchema, this.editor, {});
	}
	tryParseMarkdownToBlocks(e) {
		return zn(e, this.editor.pmSchema);
	}
	pasteHTML(e, t = !1) {
		let n = e;
		if (!t) {
			let t = this.tryParseHTMLToBlocks(e);
			n = this.blocksToFullHTML(t);
		}
		n && this.editor.prosemirrorView?.pasteHTML(n);
	}
	pasteText(e) {
		return this.editor.prosemirrorView?.pasteText(e);
	}
	pasteMarkdown(e) {
		let t = Rn(e);
		return this.pasteHTML(t);
	}
};
//#endregion
//#region src/api/blockManipulation/selections/textCursorPosition.ts
function Vn(e) {
	let { bnBlock: t } = v(e), n = _(e.doc), r = e.doc.resolve(t.beforePos), i = r.nodeBefore, a = e.doc.resolve(t.afterPos).nodeAfter, o;
	return r.depth > 1 && (o = r.node(), o.type.isInGroup("bnBlock") || (o = r.node(r.depth - 1))), {
		block: b(t.node, n),
		prevBlock: i === null ? void 0 : b(i, n),
		nextBlock: a === null ? void 0 : b(a, n),
		parentBlock: o === void 0 ? void 0 : b(o, n)
	};
}
function Hn(e, t, n = "start") {
	let r = typeof t == "string" ? t : t.id, a = g(_(e.doc)), o = i(r, e.doc);
	if (!o) throw Error(`Block with ID ${r} not found`);
	let s = ie(o), c = a.blockSchema[s.blockNoteType].content;
	if (s.isBlockContainer) {
		let t = s.blockContent;
		if (c === "none") {
			e.setSelection(M.create(e.doc, t.beforePos));
			return;
		}
		if (c === "inline") n === "start" ? e.setSelection(P.create(e.doc, t.beforePos + 1)) : e.setSelection(P.create(e.doc, t.afterPos - 1));
		else if (c === "table") n === "start" ? e.setSelection(P.create(e.doc, t.beforePos + 4)) : e.setSelection(P.create(e.doc, t.afterPos - 4));
		else throw new u(c);
	} else Hn(e, (n === "start" ? s.childContainer.node.firstChild : s.childContainer.node.lastChild).attrs.id, n);
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/tlds.ts
var Un = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/linkDetector.ts
function Wn(e) {
	let t = [], n = [], r = 0;
	for (; r < e.length;) {
		let i = 0;
		for (; r + i < e.length && e.charCodeAt(r + i) >= 48 && e.charCodeAt(r + i) <= 57;) i++;
		if (i > 0) {
			t.push(n.join(""));
			let a = parseInt(e.substring(r, r + i), 10);
			for (; a-- > 0;) n.pop();
			r += i;
		} else n.push(e[r]), r++;
	}
	return t;
}
var Gn = new Set(Wn(Un)), Kn = new Set(["localhost"]), qn = /[.,;:!?"']+$/, Jn = /(?:https?|ftp|ftps):\/\/[^\s]+/g, Yn = /mailto:[^\s]+/g, Xn = /[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}/g, Zn = /(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?::\d{1,5})?(?:[/?#][^\s]*)?/g;
function Qn(e) {
	let t = e, n = !0;
	for (; n;) {
		n = !1;
		let e = t;
		t = t.replace(qn, ""), t !== e && (n = !0);
		for (let [e, r] of [["(", ")"], ["[", "]"]]) for (; t.endsWith(r);) {
			let i = $n(t, e);
			if ($n(t, r) > i) t = t.slice(0, -1), n = !0;
			else break;
		}
	}
	return t;
}
function $n(e, t) {
	let n = 0;
	for (let r = 0; r < e.length; r++) e[r] === t && n++;
	return n;
}
function er(e) {
	let t = e.split(".");
	return t[t.length - 1].toLowerCase();
}
function tr(e) {
	let t = er(e);
	return Gn.has(t);
}
function nr(e, t, n) {
	return t === "email" ? "mailto:" + e : /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(e) || /^mailto:/i.test(e) ? e : n + "://" + e;
}
function rr(e, t) {
	if (!e) return [];
	let n = t?.defaultProtocol || "http", r = [];
	for (let t of e.matchAll(Jn)) r.push({
		type: "url",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	for (let t of e.matchAll(Yn)) r.push({
		type: "url",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	for (let t of e.matchAll(Xn)) r.push({
		type: "email",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	for (let t of e.matchAll(Zn)) r.push({
		type: "url",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	r.sort((e, t) => e.start - t.start || t.end - e.end);
	let i = [], a = -1;
	for (let e of r) e.start >= a && (i.push(e), a = e.end);
	let o = [];
	for (let e of i) {
		let t = Qn(e.value);
		if (!t) continue;
		let r = e.start, i = r + t.length;
		if (e.type === "url" && !/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(t)) {
			let e = new URL("http://" + t).hostname;
			if (!tr(e)) continue;
		}
		if (e.type === "email") {
			let e = t.split("@")[1];
			if (!tr(e)) continue;
		}
		let a = nr(t, e.type, n);
		o.push({
			type: e.type,
			value: t,
			isLink: !0,
			href: a,
			start: r,
			end: i
		});
	}
	return o;
}
function ir(e, t = "http") {
	if (!e) return [X(e, 0, 0)];
	for (let [n, r] of [
		["(", ")"],
		["[", "]"],
		["{", "}"]
	]) if (e.startsWith(n) && e.endsWith(r) && e.length > 2) {
		let i = e.slice(1, -1);
		if (ar(i)) return [
			X(n, 0, 1),
			or(i, 1, 1 + i.length, t),
			X(r, 1 + i.length, e.length)
		];
	}
	if (e.endsWith(".") && e.length > 1) {
		let n = e.slice(0, -1);
		if (ar(n)) return [or(n, 0, n.length, t), X(".", n.length, e.length)];
	}
	return ar(e) ? [or(e, 0, e.length, t)] : [X(e, 0, e.length)];
}
function ar(e) {
	if (/^(?:https?|ftp|ftps):\/\/[^\s]+$/.test(e) || /^mailto:[^\s]+$/.test(e) || Kn.has(e.toLowerCase())) return !0;
	let t = e.match(/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+([a-zA-Z]{2,})(?::\d{1,5})?(?:[/?#][^\s]*)?$/);
	if (t) {
		let e = t[1].toLowerCase();
		if (Gn.has(e)) return !0;
	}
	return !1;
}
function or(e, t, n, r) {
	let i = e.includes("@") && !e.includes("://") && !e.startsWith("mailto:") ? "email" : "url";
	return {
		type: i,
		value: e,
		isLink: !0,
		href: nr(e, i, r),
		start: t,
		end: n
	};
}
function X(e, t, n) {
	return {
		type: "text",
		value: e,
		isLink: !1,
		href: e,
		start: t,
		end: n
	};
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/whitespace.ts
var sr = "[\0- \xA0 ᠎ -\u2029 　]", cr = new RegExp(sr), lr = RegExp(`${sr}$`), ur = new RegExp(sr, "g");
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/autolink.ts
function dr(e) {
	return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function fr(e) {
	return new L({
		key: new R("autolink"),
		appendTransaction: (t, n, r) => {
			let i = t.some((e) => e.docChanged) && !n.doc.eq(r.doc), a = t.some((e) => e.getMeta("preventAutolink"));
			if (!i || a) return;
			let { tr: o } = r;
			if (Ye(We(n.doc, [...t])).forEach(({ newRange: t }) => {
				let n = Ke(r.doc, t, (e) => e.isTextblock), i, a;
				if (n.length > 1) i = n[0], a = r.doc.textBetween(i.pos, i.pos + i.node.nodeSize, void 0, " ");
				else if (n.length) {
					let e = r.doc.textBetween(t.from, t.to, " ", " ");
					if (!lr.test(e)) return;
					i = n[0], a = r.doc.textBetween(i.pos, t.to, void 0, " ");
				}
				if (i && a) {
					let t = a.split(cr).filter(Boolean);
					if (t.length <= 0) return;
					let n = t[t.length - 1], s = i.pos + a.lastIndexOf(n);
					if (!n) return;
					let c = ir(n, e.defaultProtocol);
					if (!dr(c)) return;
					c.filter((e) => e.isLink).map((e) => ({
						...e,
						from: s + e.start + 1,
						to: s + e.end + 1
					})).filter((e) => r.schema.marks.code ? !r.doc.rangeHasMark(e.from, e.to, r.schema.marks.code) : !0).filter((t) => e.validate(t.value)).filter((t) => e.shouldAutoLink(t.value)).forEach((t) => {
						Ze(t.from, t.to, r.doc).some((t) => t.mark.type === e.type) || o.addMark(t.from, t.to, e.type.create({ href: t.href }));
					});
				}
			}), o.steps.length) return o;
		}
	});
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/clickHandler.ts
function pr(e) {
	return new L({
		key: new R("handleClickLink"),
		props: { handleClick: (t, n, r) => {
			if (r.button !== 0 || !t.editable) return !1;
			let i = null;
			if (r.target instanceof HTMLAnchorElement && r.target.getAttribute("data-inline-content-type") === "link") i = r.target;
			else {
				let t = r.target;
				if (!t) return !1;
				let n = e.tiptapEditor.view.dom;
				i = t.closest("a[data-inline-content-type=\"link\"]"), i && !n.contains(i) && (i = null);
			}
			if (!i) return !1;
			if (e.onClick) {
				if (!e.editor) throw Error("BlockNoteEditor not found in Link click handler");
				return e.onClick(r, e.editor) ?? !0;
			}
			let a = Je(t.state, e.type.name), o = i.href ?? a.href, s = i.target ?? a.target;
			return o ? (window.open(o, s), !0) : !1;
		} }
	});
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/pasteHandler.ts
function mr(e) {
	return new L({
		key: new R("handlePasteLink"),
		props: { handlePaste: (t, n, r) => {
			let { shouldAutoLink: i, isValidLink: a } = e, { state: o } = t, { selection: s } = o, { empty: c } = s;
			if (c) return !1;
			let l = "";
			r.content.forEach((e) => {
				l += e.textContent;
			});
			let u = rr(l, { defaultProtocol: e.defaultProtocol }).find((e) => e.isLink && e.value === l);
			return !l || !u || !a(u.value) || i !== void 0 && !i(u.value) ? !1 : e.editor.commands.setMark(e.type, { href: u.href });
		} }
	});
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/link.ts
var hr = "https", gr = /^(?:(?:http|https|ftp|ftps|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z0-9+.\-]+(?:[^a-z+.\-:]|$))/i;
function _r(e) {
	if (!e) return !0;
	let t = e.replace(ur, "");
	return gr.test(t);
}
function Z(e) {
	let t = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), n = /^[a-z][a-z0-9+.-]*:/i.test(e);
	if (t || n && !e.includes("@")) return !0;
	let r = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
	return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(r) || !/\./.test(r));
}
var vr = k.create({
	name: "link",
	keepOnSplit: !1,
	exitable: !0,
	inclusive: !1,
	addOptions() {
		return {
			HTMLAttributes: {
				target: "_blank",
				rel: "noopener noreferrer nofollow",
				className: "bn-inline-content-section",
				"data-inline-content-type": "link"
			},
			editor: void 0,
			onClick: void 0,
			isValidLink: _r
		};
	},
	addAttributes() {
		return { href: {
			default: null,
			parseHTML(e) {
				return e.getAttribute("href");
			}
		} };
	},
	parseHTML() {
		let e = this.options.isValidLink;
		return [{
			tag: "a[href]",
			getAttrs: (t) => {
				let n = t.getAttribute("href");
				return !n || !e(n) ? !1 : null;
			}
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return this.options.isValidLink(e.href) ? [
			"a",
			tt(e, this.options.HTMLAttributes),
			0
		] : [
			"a",
			tt({
				...e,
				href: ""
			}, this.options.HTMLAttributes),
			0
		];
	},
	addPasteRules() {
		let e = this.options.isValidLink;
		return [et({
			find: (t) => {
				let n = [];
				if (t) {
					let r = rr(t, { defaultProtocol: hr }).filter((t) => t.isLink && e(t.value));
					for (let e of r) Z(e.value) && n.push({
						text: e.value,
						data: { href: e.href },
						index: e.start
					});
				}
				return n;
			},
			type: this.type,
			getAttributes: (e) => ({ href: e.data?.href })
		})];
	},
	addProseMirrorPlugins() {
		let e = [];
		return e.push(fr({
			type: this.type,
			defaultProtocol: hr,
			validate: this.options.isValidLink,
			shouldAutoLink: Z
		})), e.push(pr({
			type: this.type,
			tiptapEditor: this.editor,
			editor: this.options.editor,
			onClick: this.options.onClick
		})), e.push(mr({
			editor: this.editor,
			defaultProtocol: hr,
			type: this.type,
			shouldAutoLink: Z,
			isValidLink: this.options.isValidLink
		})), e;
	}
}), yr = Me(({ editor: e, options: t }) => ({
	key: "link",
	tiptapExtensions: [vr.configure({
		HTMLAttributes: t.HTMLAttributes ?? {},
		editor: e,
		onClick: t.onClick,
		...t.isValidLink ? { isValidLink: t.isValidLink } : {}
	})]
})), br = [
	"vscode-editor-data",
	"blocknote/html",
	"text/markdown",
	"text/html",
	"text/plain",
	"Files"
];
//#endregion
//#region src/api/clipboard/fromClipboard/handleFileInsertion.ts
function xr(e, t) {
	if (!e.startsWith(".") || !t.startsWith(".")) throw Error("The strings provided are not valid file extensions.");
	return e === t;
}
function Sr(e, t) {
	let n = e.split("/"), r = t.split("/");
	if (n.length !== 2) throw Error(`The string ${e} is not a valid MIME type.`);
	if (r.length !== 2) throw Error(`The string ${t} is not a valid MIME type.`);
	return n[1] === "*" || r[1] === "*" ? n[0] === r[0] : (n[0] === "*" || r[0] === "*" || n[0] === r[0]) && n[1] === r[1];
}
function Cr(e, t, n, r = "after") {
	let i;
	return i = Array.isArray(t.content) && t.content.length === 0 ? e.updateBlock(t, n).id : e.insertBlocks([n], t, r)[0].id, i;
}
async function wr(e, t) {
	if (!t.uploadFile) {
		console.warn("Attempted ot insert file, but uploadFile is not set in the BlockNote editor options");
		return;
	}
	let n = "dataTransfer" in e ? e.dataTransfer : e.clipboardData;
	if (n === null) return;
	let r = null;
	for (let e of br) if (n.types.includes(e)) {
		r = e;
		break;
	}
	if (r !== "Files") return;
	let i = n.items;
	if (i) {
		e.preventDefault();
		for (let n = 0; n < i.length; n++) {
			let r = "file";
			for (let e of Object.values(t.schema.blockSpecs)) for (let t of e.implementation.meta?.fileBlockAccept || []) {
				let a = t.startsWith("."), o = i[n].getAsFile();
				if (o && (!a && o.type && Sr(i[n].type, t) || a && xr("." + o.name.split(".").pop(), t))) {
					r = e.config.type;
					break;
				}
			}
			let a = i[n].getAsFile();
			if (a) {
				let n = {
					type: r,
					props: { name: a.name }
				}, i;
				if (e.type === "paste") {
					let e = t.getTextCursorPosition().block;
					i = Cr(t, e, n);
				} else if (e.type === "drop") {
					let r = {
						left: e.clientX,
						top: e.clientY
					}, a = t.prosemirrorView.posAtCoords(r);
					if (!a) return;
					i = t.transact((e) => {
						let i = C(e.doc, a.pos), o = (t.domElement?.querySelector(`[data-id="${i.node.attrs.id}"]`))?.getBoundingClientRect();
						return Cr(t, t.getBlock(i.node.attrs.id), n, o && (o.top + o.bottom) / 2 > r.top ? "before" : "after");
					});
				} else return;
				let o = await t.uploadFile(a, i), s = typeof o == "string" ? { props: { url: o } } : { ...o };
				t.updateBlock(i, s);
			}
		}
	}
}
//#endregion
//#region src/api/clipboard/fromClipboard/fileDropExtension.ts
var Tr = (e) => O.create({
	name: "dropFile",
	addProseMirrorPlugins() {
		return [new N({ props: { handleDOMEvents: { drop(t, n) {
			if (!e.isEditable) return;
			let r = null;
			for (let e of br) if (n.dataTransfer.types.includes(e)) {
				r = e;
				break;
			}
			return r === null ? !0 : r === "Files" ? (wr(n, e), !0) : !1;
		} } } })];
	}
}), Er = /(^|\n) {0,3}#{1,6} {1,8}[^\n]{1,64}\r?\n\r?\n\s{0,32}\S/, Dr = /(_|__|\*|\*\*|~~|==|\+\+)(?!\s)(?:[^\s](?:.{0,62}[^\s])?|\S)(?=\1)/, Or = /\[[^\]]{1,128}\]\(https?:\/\/\S{1,999}\)/, kr = /(?:\s|^)`(?!\s)(?:[^\s`](?:[^`]{0,46}[^\s`])?|[^\s`])`([^\w]|$)/, Ar = /(?:^|\n)\s{0,5}-\s{1}[^\n]+\n\s{0,15}-\s/, jr = /(?:^|\n)\s{0,5}\d+\.\s{1}[^\n]+\n\s{0,15}\d+\.\s/, Mr = /\n{2} {0,3}-{2,48}\n{2}/, Nr = /(?:\n|^)(```|~~~|\$\$)(?!`|~)[^\s]{0,64} {0,64}[^\n]{0,64}\n[\s\S]{0,9999}?\s*\1 {0,64}(?:\n+|$)/, Pr = /(?:\n|^)(?!\s)\w[^\n]{0,64}\r?\n(-|=)\1{0,64}\n\n\s{0,64}(\w|$)/, Fr = /(?:^|(\r?\n\r?\n))( {0,3}>[^\n]{1,333}\n){1,999}($|(\r?\n))/, Ir = /^\s*\|(.+\|)+\s*$/m, Lr = /^\s*\|(\s*[-:]+[-:]\s*\|)+\s*$/m, Rr = /^\s*\|(.+\|)+\s*$/m, zr = (e) => Er.test(e) || Dr.test(e) || Or.test(e) || kr.test(e) || Ar.test(e) || jr.test(e) || Mr.test(e) || Nr.test(e) || Pr.test(e) || Fr.test(e) || Ir.test(e) || Lr.test(e) || Rr.test(e);
//#endregion
//#region src/api/clipboard/fromClipboard/handleVSCodePaste.ts
function Br(e, t) {
	let { schema: n } = t.state;
	if (!e.clipboardData) return !1;
	let r = e.clipboardData.getData("text/plain");
	if (!r || !n.nodes.codeBlock) return !1;
	let i = e.clipboardData.getData("vscode-editor-data"), a = (i ? JSON.parse(i) : void 0)?.mode;
	return a ? (t.pasteHTML(`<pre><code class="language-${a}">${r.replace(/\r\n?/g, "\n")}</code></pre>`), !0) : !1;
}
//#endregion
//#region src/api/clipboard/fromClipboard/pasteExtension.ts
function Vr({ event: e, editor: t, prioritizeMarkdownOverHTML: n, plainTextAsMarkdown: r }) {
	if (t.transact((e) => e.selection.$from.parent.type.spec.code && e.selection.$to.parent.type.spec.code)) {
		let n = e.clipboardData?.getData("text/plain");
		if (n) return t.pasteText(n), !0;
	}
	let i;
	for (let t of br) if (e.clipboardData.types.includes(t)) {
		i = t;
		break;
	}
	if (!i) return !0;
	if (i === "vscode-editor-data") {
		if (Br(e, t.prosemirrorView)) return !0;
		i = "text/plain";
	}
	if (i === "Files") return wr(e, t), !0;
	let a = e.clipboardData.getData(i);
	if (i === "blocknote/html") return t.pasteHTML(a, !0), !0;
	if (i === "text/markdown") return t.pasteMarkdown(a), !0;
	if (n) {
		let n = e.clipboardData.getData("text/plain");
		if (zr(n)) return t.pasteMarkdown(n), !0;
	}
	return i === "text/html" ? (t.pasteHTML(a), !0) : r ? (t.pasteMarkdown(a), !0) : (t.pasteText(a), !0);
}
var Hr = (e, t) => O.create({
	name: "pasteFromClipboard",
	addProseMirrorPlugins() {
		return [new N({ props: { handleDOMEvents: { paste(n, r) {
			if (r.preventDefault(), e.isEditable) return t({
				event: r,
				editor: e,
				defaultPasteHandler: ({ prioritizeMarkdownOverHTML: t = !0, plainTextAsMarkdown: n = !0 } = {}) => Vr({
					event: r,
					editor: e,
					prioritizeMarkdownOverHTML: t,
					plainTextAsMarkdown: n
				})
			});
		} } } })];
	}
});
//#endregion
//#region src/api/clipboard/toClipboard/copyExtension.ts
function Ur(e, t, n) {
	let r = !1, i = e.state.selection instanceof I;
	if (!i) {
		let n = e.state.doc.slice(e.state.selection.from, e.state.selection.to, !1).content, i = [];
		for (let e = 0; e < n.childCount; e++) i.push(n.child(e));
		r = i.find((e) => e.type.isInGroup("bnBlock") || e.type.name === "blockGroup" || e.type.spec.group === "blockContent") === void 0, r && (t = n);
	}
	let a, o = be(e.state.schema, n);
	if (i) {
		t.firstChild?.type.name === "table" && (t = t.firstChild.content);
		let e = ne(t, n.schema.inlineContentSchema, n.schema.styleSchema);
		a = `<table>${o.exportInlineContent(e, {})}</table>`;
	} else if (r) {
		let e = ce(t, n.schema.inlineContentSchema, n.schema.styleSchema);
		a = o.exportInlineContent(e, {});
	} else {
		let e = xe(t);
		a = o.exportBlocks(e, {});
	}
	return a;
}
function Wr(e, t) {
	"node" in e.state.selection && e.state.selection.node.type.spec.group === "blockContent" && t.transact((t) => t.setSelection(new M(t.doc.resolve(e.state.selection.from - 1))));
	let n = e.serializeForClipboard(e.state.selection.content()).dom.innerHTML, r = e.state.selection.content().content, i = Ur(e, r, t);
	return {
		clipboardHTML: n,
		externalHTML: i,
		markdown: ve(i)
	};
}
var Gr = (e) => {
	if (e.state.selection.empty) return !0;
	let t = window.getSelection();
	if (t && !t.isCollapsed) {
		let e = t.focusNode;
		for (; e;) {
			if (e instanceof HTMLElement && e.getAttribute("contenteditable") === "false") return !0;
			e = e.parentElement;
		}
	}
	return !1;
}, Kr = (e, t, n) => {
	n.preventDefault(), n.clipboardData.clearData();
	let { clipboardHTML: r, externalHTML: i, markdown: a } = Wr(t, e);
	n.clipboardData.setData("blocknote/html", r), n.clipboardData.setData("text/html", i), n.clipboardData.setData("text/plain", a);
}, qr = (e) => O.create({
	name: "copyToClipboard",
	addProseMirrorPlugins() {
		return [new N({ props: { handleDOMEvents: {
			copy(t, n) {
				return Gr(t) || Kr(e, t, n), !0;
			},
			cut(t, n) {
				return Gr(t) ? !0 : (Kr(e, t, n), t.editable && t.dispatch(t.state.tr.deleteSelection()), !0);
			},
			dragstart(t, n) {
				if (!("node" in t.state.selection) || t.state.selection.node.type.spec.group !== "blockContent") return;
				e.transact((e) => e.setSelection(new M(e.doc.resolve(t.state.selection.from - 1)))), n.preventDefault(), n.dataTransfer.clearData();
				let { clipboardHTML: r, externalHTML: i, markdown: a } = Wr(t, e);
				return n.dataTransfer.setData("blocknote/html", r), n.dataTransfer.setData("text/html", i), n.dataTransfer.setData("text/plain", a), !0;
			}
		} } })];
	}
}), Jr = O.create({
	name: "blockBackgroundColor",
	addGlobalAttributes() {
		return [{
			types: ["tableCell", "tableHeader"],
			attributes: { backgroundColor: te() }
		}];
	}
}), Yr = A.create({
	name: "hardBreak",
	inline: !0,
	group: "inline",
	selectable: !1,
	linebreakReplacement: !0,
	priority: 10,
	parseHTML() {
		return [{ tag: "br" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["br", tt(this.options.HTMLAttributes, e)];
	},
	renderText() {
		return "\n";
	}
}), Xr = (e, t) => {
	let n = e.resolve(t), r = n.depth - 1;
	if (r < 1) return;
	let i = n.before(r), a = e.resolve(i).nodeAfter;
	if (a) return a.type.spec.group?.includes("bnBlock") ? S(e.resolve(i)) : Xr(e, i);
}, Q = (e, t) => {
	let n = e.resolve(t), r = n.index();
	if (r === 0) return;
	let i = n.posAtIndex(r - 1);
	return S(e.resolve(i));
}, $ = (e, t) => {
	let n = e.resolve(t), r = n.index();
	if (r === n.node().childCount - 1) return;
	let i = n.posAtIndex(r + 1);
	return S(e.resolve(i));
}, Zr = (e, t) => {
	for (; t.childContainer;) {
		let n = t.childContainer.node, r = e.resolve(t.childContainer.beforePos + 1).posAtIndex(n.childCount - 1);
		t = S(e.resolve(r));
	}
	return t;
}, Qr = (e, t) => e.isBlockContainer && e.blockContent.node.type.spec.content === "inline*" && e.blockContent.node.childCount > 0 && t.isBlockContainer && t.blockContent.node.type.spec.content === "inline*", $r = (e, t, n, r) => {
	if (!r.isBlockContainer) throw Error(`Attempted to merge block at position ${r.bnBlock.beforePos} into previous block at position ${n.bnBlock.beforePos}, but next block is not a block container`);
	if (r.childContainer) {
		let n = e.doc.resolve(r.childContainer.beforePos + 1), i = e.doc.resolve(r.childContainer.afterPos - 1), a = n.blockRange(i);
		if (t) {
			let t = e.doc.resolve(r.bnBlock.beforePos);
			e.tr.lift(a, t.depth);
		}
	}
	if (t) {
		if (!n.isBlockContainer) throw Error(`Attempted to merge block at position ${r.bnBlock.beforePos} into previous block at position ${n.bnBlock.beforePos}, but previous block is not a block container`);
		t(e.tr.delete(n.blockContent.afterPos - 1, r.blockContent.beforePos + 1));
	}
	return !0;
}, ei = (e) => ({ state: t, dispatch: n }) => {
	let r = S(t.doc.resolve(e)), i = Q(t.doc, r.bnBlock.beforePos);
	if (!i) return !1;
	let a = Zr(t.doc, i);
	return Qr(a, r) ? $r(t, n, a, r) : !1;
}, ti = O.create({
	priority: 50,
	addKeyboardShortcuts() {
		let e = () => this.editor.commands.first(({ chain: e, commands: t }) => [
			() => t.deleteSelection(),
			() => t.undoInputRule(),
			() => t.command(({ state: e }) => {
				let n = y(e);
				if (!n.isBlockContainer) return !1;
				let r = e.selection.from === n.blockContent.beforePos + 1, i = n.blockContent.node.type.name === "paragraph";
				return r && !i ? t.command(ue(n.bnBlock.beforePos, {
					type: "paragraph",
					props: {}
				})) : !1;
			}),
			() => t.command(({ state: e, tr: t }) => {
				let n = y(e);
				if (!n.isBlockContainer) return !1;
				let { blockContent: r } = n;
				return e.selection.from === r.beforePos + 1 ? U(t, t.doc.type.schema.nodes.blockContainer, t.doc.type.schema.nodes.blockGroup) : !1;
			}),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer) return !1;
				let { bnBlock: r, blockContent: i } = n, a = Q(t.doc, n.bnBlock.beforePos);
				if (!a || !a.isBlockContainer || a.blockContent.node.type.spec.content !== "inline*") return !1;
				let o = t.selection.from === i.beforePos + 1, s = t.selection.empty, c = r.beforePos;
				return o && s ? e().command(ei(c)).scrollIntoView().run() : !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = y(e);
				if (!r.isBlockContainer || e.selection.from !== r.blockContent.beforePos + 1) return !1;
				let i = Q(e.doc, r.bnBlock.beforePos);
				if (!i || i.isBlockContainer) return !1;
				if (n) {
					let e = i.bnBlock.afterPos - 1, n = t.doc.resolve(e - 1);
					return t.delete(r.bnBlock.beforePos, r.bnBlock.afterPos), t.insert(n.pos, r.bnBlock.node), t.setSelection(P.near(t.doc.resolve(n.pos + 1))), !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = y(e);
				if (!r.isBlockContainer || t.selection.from !== r.blockContent.beforePos + 1) return !1;
				let i = t.doc.resolve(r.bnBlock.beforePos);
				if (i.nodeBefore || i.node().type.name !== "column") return !1;
				let a = t.doc.resolve(r.bnBlock.beforePos), o = t.doc.resolve(a.before()), s = o.before();
				return n && (t.delete(r.bnBlock.beforePos, r.bnBlock.afterPos), B(t, s), o.pos === s + 1 ? (t.insert(s, r.bnBlock.node), t.setSelection(P.near(t.doc.resolve(s)))) : (t.insert(o.pos - 1, r.bnBlock.node), t.setSelection(P.near(t.doc.resolve(o.pos))))), !0;
			}),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer) return !1;
				if (n.blockContent.node.childCount === 0 && n.blockContent.node.type.spec.content === "inline*") {
					let r = Q(t.doc, n.bnBlock.beforePos);
					if (!r) return !1;
					let i = Zr(t.doc, r);
					if (!i.isBlockContainer || !i || !i.isBlockContainer) return !1;
					let a = e();
					if (n.childContainer && a.insertContentAt(n.bnBlock.afterPos, n.childContainer?.node.content), i.blockContent.node.type.spec.content === "tableRow+") {
						let e = n.bnBlock.beforePos - 1 - 1 - 1 - 1 - 1;
						a = a.setTextSelection(e);
					} else if (i.blockContent.node.type.spec.content === "") a = a.setNodeSelection(i.blockContent.beforePos);
					else {
						let e = i.blockContent.afterPos - 1;
						a = a.setTextSelection(e);
					}
					return a.deleteRange({
						from: n.bnBlock.beforePos,
						to: n.bnBlock.afterPos
					}).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer) return !1;
				let r = t.selection.from === n.blockContent.beforePos + 1, i = t.selection.empty, a = Q(t.doc, n.bnBlock.beforePos);
				if (a && r && i) {
					let r = Zr(t.doc, a);
					if (!r.isBlockContainer) return !1;
					if (r.blockContent.node.type.spec.content === "" || r.blockContent.node.type.spec.content === "inline*" && r.blockContent.node.childCount === 0) return e().cut({
						from: n.bnBlock.beforePos,
						to: n.bnBlock.afterPos
					}, r.bnBlock.afterPos).deleteRange({
						from: r.bnBlock.beforePos,
						to: r.bnBlock.afterPos
					}).run();
				}
				return !1;
			})
		]), t = () => this.editor.commands.first(({ chain: e, commands: t }) => [
			() => t.deleteSelection(),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer || !n.childContainer) return !1;
				let { blockContent: r, childContainer: i } = n, a = t.selection.from === r.afterPos - 1, o = t.selection.empty, s = S(t.doc.resolve(i.beforePos + 1));
				if (!s.isBlockContainer) return !1;
				if (a && o) {
					let n = s.blockContent.node, a = n.type.spec.content === "inline*", o = r.node.type.spec.content === "inline*";
					return e().insertContentAt(s.bnBlock.afterPos, s.childContainer?.node.content || T.empty).deleteRange(i.node.childCount === 1 ? {
						from: i.beforePos,
						to: i.afterPos
					} : {
						from: s.bnBlock.beforePos,
						to: s.bnBlock.afterPos
					}).insertContentAt(t.selection.from, a && o ? n.content : null).setTextSelection(t.selection.from).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer) return !1;
				let { bnBlock: r, blockContent: i } = n, a = $(t.doc, n.bnBlock.beforePos);
				if (!a || !a.isBlockContainer) return !1;
				let o = t.selection.from === i.afterPos - 1, s = t.selection.empty, c = r.afterPos;
				return o && s ? e().command(ei(c)).scrollIntoView().run() : !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = y(e);
				if (!r.isBlockContainer || e.selection.from !== r.blockContent.afterPos - 1) return !1;
				let i = $(e.doc, r.bnBlock.beforePos);
				if (!i || i.isBlockContainer) return !1;
				if (n) {
					let e = i.bnBlock.beforePos + 1, n = t.doc.resolve(e + 1);
					return t.delete(n.pos, n.pos + n.nodeAfter.nodeSize), B(t, i.bnBlock.beforePos), t.insert(r.bnBlock.afterPos, n.nodeAfter), t.setSelection(P.near(t.doc.resolve(n.pos))), !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = y(e);
				if (!r.isBlockContainer || t.selection.from !== r.blockContent.afterPos - 1) return !1;
				let i = t.doc.resolve(r.bnBlock.afterPos);
				if (i.nodeAfter || i.node().type.name !== "column") return !1;
				let a = t.doc.resolve(r.bnBlock.afterPos), o = t.doc.resolve(a.after()), s = o.after();
				if (n) {
					let e = o.pos === s - 1 ? s : o.pos + 1, n = S(t.doc.resolve(e));
					t.delete(n.bnBlock.beforePos, n.bnBlock.afterPos), B(t, s - o.node().nodeSize), t.insert(a.pos, n.bnBlock.node), t.setSelection(P.near(t.doc.resolve(e)));
				}
				return !0;
			}),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer) return !1;
				let { blockContent: r } = n, i = t.selection.from === r.afterPos - 1, a = t.selection.empty;
				if (i && a) {
					let i = (e, t) => {
						let n = $(e, t);
						if (n) return n;
						let r = Xr(e, t);
						if (r) return i(e, r.bnBlock.beforePos);
					}, a = i(t.doc, n.bnBlock.beforePos);
					if (!a || !a.isBlockContainer) return !1;
					let o = a.blockContent.node, s = o.type.spec.content === "inline*", c = r.node.type.spec.content === "inline*";
					return e().insertContentAt(a.bnBlock.afterPos, a.childContainer?.node.content || T.empty).deleteRange({
						from: a.bnBlock.beforePos,
						to: a.bnBlock.afterPos
					}).insertContentAt(t.selection.from, s && c ? o.content : null).setTextSelection(t.selection.from).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer) return !1;
				if (n.blockContent.node.childCount === 0 && n.blockContent.node.type.spec.content === "inline*") {
					let r = $(t.doc, n.bnBlock.beforePos);
					if (!r || !r.isBlockContainer) return !1;
					let i = e();
					if (r.blockContent.node.type.spec.content === "tableRow+") {
						let e = n.bnBlock.afterPos + 1 + 1 + 1 + 1 + 1;
						i = i.setTextSelection(e);
					} else i = r.blockContent.node.type.spec.content === "" ? i.setNodeSelection(r.blockContent.beforePos) : i.setTextSelection(r.blockContent.beforePos + 1);
					return i.deleteRange({
						from: n.bnBlock.beforePos,
						to: n.bnBlock.afterPos
					}).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = y(t);
				if (!n.isBlockContainer) return !1;
				let r = t.selection.from === n.blockContent.afterPos - 1, i = t.selection.empty, a = $(t.doc, n.bnBlock.beforePos);
				if (!a || !a.isBlockContainer) return !1;
				if (a && r && i && (a.blockContent.node.type.spec.content === "" || a.blockContent.node.type.spec.content === "inline*" && a.blockContent.node.childCount === 0)) {
					let t = a.bnBlock.node.lastChild.content;
					return e().deleteRange({
						from: a.bnBlock.beforePos,
						to: a.bnBlock.afterPos
					}).insertContentAt(n.bnBlock.afterPos, a.bnBlock.node.childCount === 2 ? t : null).run();
				}
				return !1;
			})
		]), n = (e = !1) => this.editor.commands.first(({ commands: t, tr: n }) => [
			() => t.command(({ state: e, tr: t }) => {
				let n = y(e);
				if (!n.isBlockContainer) return !1;
				let { bnBlock: r, blockContent: i } = n, { depth: a } = e.doc.resolve(r.beforePos), o = e.selection.$anchor.parentOffset === 0, s = e.selection.anchor === e.selection.head, c = i.node.childCount === 0;
				return o && s && c && a > 1 ? U(t, t.doc.type.schema.nodes.blockContainer, t.doc.type.schema.nodes.blockGroup) : !1;
			}),
			() => t.command(({ state: t }) => {
				let r = y(t), i = this.options.editor.schema.blockSchema[r.blockNoteType].meta?.hardBreakShortcut ?? "shift+enter";
				if (i === "none") return !1;
				if (i === "shift+enter" && e || i === "enter") {
					let e = n.storedMarks || n.selection.$head.marks().filter((e) => this.editor.extensionManager.splittableMarks.includes(e.type.name));
					return n.insert(n.selection.head, n.doc.type.schema.nodes.hardBreak.create()).ensureMarks(e), !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, dispatch: t, tr: n }) => {
				let r = y(e);
				if (!r.isBlockContainer) return !1;
				let { bnBlock: i, blockContent: a } = r, o = e.selection.$anchor.parentOffset === 0, s = e.selection.anchor === e.selection.head, c = a.node.childCount === 0;
				if (o && s && c) {
					let a = i.afterPos, o = a + 2;
					if (t) {
						let t = e.schema.nodes.blockContainer.createAndFill(void 0, [e.schema.nodes.paragraph.createAndFill() || void 0, r.childContainer?.node].filter((e) => e !== void 0));
						n.insert(a, t).setSelection(new P(n.doc.resolve(o))).scrollIntoView(), r.childContainer && n.delete(r.childContainer.beforePos, r.childContainer.afterPos);
					}
					return !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, chain: t }) => {
				let n = y(e);
				if (!n.isBlockContainer) return !1;
				let { blockContent: r } = n, i = e.selection.$anchor.parentOffset === 0;
				return r.node.childCount === 0 ? !1 : (t().deleteSelection().command(f(e.selection.from, i, i)).run(), !0);
			})
		]);
		return {
			Backspace: e,
			Delete: t,
			Enter: () => n(),
			"Shift-Enter": () => n(!0),
			Tab: () => this.options.tabBehavior !== "prefer-indent" && (this.options.editor.getExtension(w)?.store.state || this.options.editor.getExtension(ae)?.store.state !== void 0) ? !1 : Ft(this.options.editor),
			"Shift-Tab": () => this.options.tabBehavior !== "prefer-indent" && (this.options.editor.getExtension(w)?.store.state || this.options.editor.getExtension(ae)?.store.state !== void 0) ? !1 : Lt(this.options.editor),
			"Shift-Mod-ArrowUp": () => (this.options.editor.moveBlocksUp(), !0),
			"Shift-Mod-ArrowDown": () => (this.options.editor.moveBlocksDown(), !0),
			"Mod-z": () => this.options.editor.undo(),
			"Mod-y": () => this.options.editor.redo(),
			"Shift-Mod-z": () => this.options.editor.redo()
		};
	}
}), ni = k.create({
	name: "insertion",
	inclusive: !1,
	excludes: "deletion modification insertion",
	addAttributes() {
		return { id: {
			default: null,
			validate: "number"
		} };
	},
	extendMarkSchema(e) {
		return e.name === "insertion" ? {
			blocknoteIgnore: !0,
			inclusive: !1,
			toDOM(e, t) {
				return [
					"ins",
					{
						"data-id": String(e.attrs.id),
						"data-inline": String(t),
						...!t && { style: "display: contents" }
					},
					0
				];
			},
			parseDOM: [{
				tag: "ins",
				getAttrs(e) {
					return e.dataset.id ? { id: parseInt(e.dataset.id, 10) } : !1;
				}
			}]
		} : {};
	}
}), ri = k.create({
	name: "deletion",
	inclusive: !1,
	excludes: "insertion modification deletion",
	addAttributes() {
		return { id: {
			default: null,
			validate: "number"
		} };
	},
	extendMarkSchema(e) {
		return e.name === "deletion" ? {
			blocknoteIgnore: !0,
			inclusive: !1,
			toDOM(e, t) {
				return [
					"del",
					{
						"data-id": String(e.attrs.id),
						"data-inline": String(t),
						...!t && { style: "display: contents" }
					},
					0
				];
			},
			parseDOM: [{
				tag: "del",
				getAttrs(e) {
					return e.dataset.id ? { id: parseInt(e.dataset.id, 10) } : !1;
				}
			}]
		} : {};
	}
}), ii = k.create({
	name: "modification",
	inclusive: !1,
	excludes: "deletion insertion",
	addAttributes() {
		return {
			id: {
				default: null,
				validate: "number"
			},
			type: { validate: "string" },
			attrName: {
				default: null,
				validate: "string|null"
			},
			previousValue: { default: null },
			newValue: { default: null }
		};
	},
	extendMarkSchema(e) {
		return e.name === "modification" ? {
			blocknoteIgnore: !0,
			inclusive: !1,
			toDOM(e, t) {
				return [
					t ? "span" : "div",
					{
						"data-type": "modification",
						"data-id": String(e.attrs.id),
						"data-mod-type": e.attrs.type,
						"data-mod-prev-val": JSON.stringify(e.attrs.previousValue),
						"data-mod-new-val": JSON.stringify(e.attrs.newValue)
					},
					0
				];
			},
			parseDOM: [{
				tag: "span[data-type='modification']",
				getAttrs(e) {
					return e.dataset.id ? {
						id: parseInt(e.dataset.id, 10),
						type: e.dataset.modType,
						previousValue: e.dataset.modPrevVal,
						newValue: e.dataset.modNewVal
					} : !1;
				}
			}, {
				tag: "div[data-type='modification']",
				getAttrs(e) {
					return e.dataset.id ? {
						id: parseInt(e.dataset.id, 10),
						type: e.dataset.modType,
						previousValue: e.dataset.modPrevVal
					} : !1;
				}
			}]
		} : {};
	}
}), ai = O.create({
	name: "textAlignment",
	addGlobalAttributes() {
		return [{
			types: ["tableCell", "tableHeader"],
			attributes: { textAlignment: {
				default: "left",
				parseHTML: (e) => e.getAttribute("data-text-alignment"),
				renderHTML: (e) => e.textAlignment === "left" ? {} : { "data-text-alignment": e.textAlignment }
			} }
		}];
	}
}), oi = O.create({
	name: "blockTextColor",
	addGlobalAttributes() {
		return [{
			types: [
				"table",
				"tableCell",
				"tableHeader"
			],
			attributes: { textColor: le() }
		}];
	}
}), si = {
	blockColor: "data-block-color",
	blockStyle: "data-block-style",
	id: "data-id",
	depth: "data-depth",
	depthChange: "data-depth-change"
}, ci = A.create({
	name: "blockContainer",
	group: "blockGroupChild bnBlock",
	content: "blockContent blockGroup?",
	priority: 50,
	defining: !0,
	marks: "insertion modification deletion",
	parseHTML() {
		return [{
			tag: "div[data-node-type=" + this.name + "]",
			getAttrs: (e) => {
				if (typeof e == "string") return !1;
				let t = {};
				for (let [n, r] of Object.entries(si)) e.getAttribute(r) && (t[n] = e.getAttribute(r));
				return t;
			}
		}, {
			tag: "div[data-node-type=\"blockOuter\"]",
			skip: !0
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		let t = document.createElement("div");
		t.className = "bn-block-outer", t.setAttribute("data-node-type", "blockOuter");
		for (let [n, r] of Object.entries(e)) n !== "class" && t.setAttribute(n, r);
		let n = {
			...this.options.domAttributes?.block || {},
			...e
		}, r = document.createElement("div");
		r.className = s("bn-block", n.class), r.setAttribute("data-node-type", this.name);
		for (let [e, t] of Object.entries(n)) e !== "class" && r.setAttribute(e, t);
		return t.appendChild(r), {
			dom: t,
			contentDOM: r
		};
	}
}), li = A.create({
	name: "blockGroup",
	group: "childContainer",
	content: "blockGroupChild+",
	marks: "deletion insertion modification",
	parseHTML() {
		return [{
			tag: "div",
			getAttrs: (e) => typeof e == "string" ? !1 : e.getAttribute("data-node-type") === "blockGroup" ? null : !1
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		let t = {
			...this.options.domAttributes?.blockGroup || {},
			...e
		}, n = document.createElement("div");
		n.className = s("bn-block-group", t.class), n.setAttribute("data-node-type", "blockGroup");
		for (let [e, r] of Object.entries(t)) e !== "class" && n.setAttribute(e, r);
		return {
			dom: n,
			contentDOM: n
		};
	}
}), ui = A.create({
	name: "doc",
	topNode: !0,
	content: "blockGroup",
	marks: "insertion modification deletion"
}), di = Me(({ options: e }) => ({
	key: "collaboration",
	blockNoteExtensions: [
		de(e),
		pe(e),
		ge(e),
		ke(),
		he(e)
	]
}));
//#endregion
//#region src/editor/managers/ExtensionManager/extensions.ts
function fi(e, t) {
	return [
		j.ClipboardTextSerializer,
		j.Commands,
		j.Editable,
		j.FocusEvents,
		j.Tabindex,
		lt,
		o.configure({
			types: [
				"blockContainer",
				"columnList",
				"column"
			],
			setIdAttribute: t.setIdAttribute,
			isWithinEditor: e.isWithinEditor
		}),
		Yr,
		ut,
		ni,
		ri,
		ii,
		...Object.values(e.schema.styleSpecs).map((t) => t.implementation.mark.configure({ editor: e })),
		oi,
		Jr,
		ai,
		O.create({
			name: "OverrideEscape",
			addKeyboardShortcuts: () => ({ Escape: () => e.getExtension(ee)?.shown() ? !1 : (e.blur(), !0) })
		}),
		ui,
		ci.configure({
			editor: e,
			domAttributes: t.domAttributes
		}),
		ti.configure({
			editor: e,
			tabBehavior: t.tabBehavior
		}),
		li.configure({ domAttributes: t.domAttributes }),
		...Object.values(e.schema.inlineContentSpecs).filter((e) => e.config !== "link" && e.config !== "text").map((t) => t.implementation.node.configure({ editor: e })),
		...Object.values(e.schema.blockSpecs).flatMap((n) => [..."node" in n.implementation ? [n.implementation.node.configure({
			editor: e,
			domAttributes: t.domAttributes
		})] : []]),
		qr(e),
		Hr(e, t.pasteHandler || ((e) => e.defaultPasteHandler())),
		Tr(e)
	];
}
function pi(e, t) {
	let n = [
		fe(),
		Ae(t),
		ae(t),
		w(t),
		yr({
			HTMLAttributes: t.links?.HTMLAttributes ?? {},
			onClick: t.links?.onClick,
			...t.links?.isValidLink ? { isValidLink: t.links.isValidLink } : {}
		}),
		_e(t),
		Se(),
		Te(t),
		Ne(t),
		we(t),
		ee(t),
		...t.trailingBlock === !1 ? [] : [Ee()]
	];
	return t.collaboration ? n.push(di(t.collaboration)) : n.push(Oe()), "table" in e.schema.blockSpecs && n.push(Ce(t)), t.animations !== !1 && n.push(ye()), n;
}
//#endregion
//#region src/editor/managers/ExtensionManager/index.ts
var mi = class {
	disabledExtensions = /* @__PURE__ */ new Set();
	extensions = [];
	abortMap = /* @__PURE__ */ new Map();
	extensionFactories = /* @__PURE__ */ new Map();
	extensionPlugins = /* @__PURE__ */ new Map();
	constructor(e, t) {
		this.editor = e, this.options = t, e.onMount(() => {
			for (let t of this.extensions) if (t.mount) {
				let n = new window.AbortController(), r = t.mount({
					dom: e.prosemirrorView.dom,
					root: e.prosemirrorView.root,
					signal: n.signal
				});
				r && n.signal.addEventListener("abort", () => {
					r();
				}), this.abortMap.set(t, n);
			}
		}), e.onUnmount(() => {
			for (let [e, t] of this.abortMap.entries()) this.abortMap.delete(e), t.abort();
		}), this.disabledExtensions = new Set(t.disableExtensions || []);
		for (let e of pi(this.editor, this.options)) this.addExtension(e);
		for (let e of this.options.extensions ?? []) this.addExtension(e);
		for (let e of Object.values(this.editor.schema.blockSpecs)) for (let t of e.extensions ?? []) this.addExtension(t);
	}
	registerExtension(e) {
		let t = [].concat(e).filter(Boolean);
		if (!t.length) {
			console.warn("No extensions found to register", e);
			return;
		}
		let n = t.map((e) => this.addExtension(e)).filter(Boolean), r = /* @__PURE__ */ new Set();
		for (let e of n) e?.tiptapExtensions && console.warn(`Extension ${e.key} has tiptap extensions, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`, e), e?.inputRules?.length && console.warn(`Extension ${e.key} has input rules, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`, e), this.getProsemirrorPluginsFromExtension(e).plugins.forEach((e) => {
			r.add(e);
		});
		this.updatePlugins((e) => [...e, ...r]);
	}
	addExtension(e) {
		let t;
		if (t = typeof e == "function" ? e({ editor: this.editor }) : e, !(!t || this.disabledExtensions.has(t.key))) {
			if (typeof e == "function") {
				let e = t[je];
				typeof e == "function" && this.extensionFactories.set(e, t);
			}
			if (this.extensions.push(t), t.blockNoteExtensions) for (let e of t.blockNoteExtensions) this.addExtension(e);
			return t;
		}
	}
	resolveExtensions(e) {
		let t = [];
		if (typeof e == "function") {
			let n = this.extensionFactories.get(e);
			n && t.push(n);
		} else if (Array.isArray(e)) for (let n of e) t.push(...this.resolveExtensions(n));
		else if (typeof e == "object" && "key" in e) t.push(e);
		else if (typeof e == "string") {
			let n = this.extensions.find((t) => t.key === e);
			n && t.push(n);
		}
		return t;
	}
	unregisterExtension(e) {
		let t = this.resolveExtensions(e);
		if (!t.length) {
			console.warn("No extensions found to unregister", e);
			return;
		}
		let n = !1, r = /* @__PURE__ */ new Set();
		for (let i of t) this.extensions = this.extensions.filter((e) => e !== i), this.extensionFactories.forEach((e, t) => {
			e === i && this.extensionFactories.delete(t);
		}), this.abortMap.get(i)?.abort(), this.abortMap.delete(i), this.extensionPlugins.get(i)?.forEach((e) => {
			r.add(e);
		}), this.extensionPlugins.delete(i), i.tiptapExtensions && !n && (n = !0, console.warn(`Extension ${i.key} has tiptap extensions, but they will not be removed. Please separate the extension into multiple extensions if you want to remove them, or re-initialize the editor.`, e));
		this.updatePlugins((e) => e.filter((e) => !r.has(e)));
	}
	updatePlugins(e) {
		let t = this.editor.prosemirrorState, n = t.reconfigure({ plugins: e(t.plugins.slice()) });
		this.editor.prosemirrorView.updateState(n);
	}
	getTiptapExtensions() {
		let e = fi(this.editor, this.options).filter((e) => !this.disabledExtensions.has(e.name)), t = a(this.extensions), n = /* @__PURE__ */ new Map();
		for (let r of this.extensions) {
			r.tiptapExtensions && e.push(...r.tiptapExtensions);
			let i = t(r.key), { plugins: a, inputRules: o } = this.getProsemirrorPluginsFromExtension(r);
			a.length && e.push(O.create({
				name: r.key,
				priority: i,
				addProseMirrorPlugins: () => a
			})), o.length && (n.has(i) || n.set(i, []), n.get(i).push(...o));
		}
		e.push(O.create({
			name: "blocknote-input-rules",
			addProseMirrorPlugins() {
				let e = [];
				Array.from(n.keys()).sort().reverse().forEach((t) => {
					e.push(...n.get(t));
				});
				let t = st({ rules: e });
				return [t, new N({ props: { handleKeyDown(e, n) {
					if (n.key !== "Enter" || n.shiftKey || n.ctrlKey || n.metaKey || n.altKey) return !1;
					let { $cursor: r } = e.state.selection;
					return r ? !!t.props.handleTextInput?.call(t, e, r.pos, r.pos, "\n", () => e.state.tr.insertText("\n", r.pos, r.pos)) : !1;
				} } })];
			}
		}));
		for (let t of this.options._tiptapOptions?.extensions ?? []) e.push(t);
		return e;
	}
	getProsemirrorPluginsFromExtension(e) {
		let t = [...e.prosemirrorPlugins ?? []], n = [];
		return !e.prosemirrorPlugins?.length && !Object.keys(e.keyboardShortcuts || {}).length && !e.inputRules?.length ? {
			plugins: t,
			inputRules: n
		} : (this.extensionPlugins.set(e, t), e.inputRules?.length && n.push(...e.inputRules.map((e) => new ot(e.find, (t, n, r, i) => {
			let a = e.replace({
				match: n,
				range: {
					from: r,
					to: i
				},
				editor: this.editor
			});
			if (a) {
				let e = t.tr, n = v(e);
				if (!n.isBlockContainer || this.editor.schema.blockSchema[n.blockNoteType]?.content !== "inline") return null;
				e.deleteRange(r, i), d(e, n.bnBlock.beforePos, a);
				let o = n.bnBlock.node.attrs.id;
				return o && Hn(e, o, "start"), e;
			}
			return null;
		}, { undoable: !0 }))), Object.keys(e.keyboardShortcuts || {}).length && t.push(ct(Object.fromEntries(Object.entries(e.keyboardShortcuts).map(([e, t]) => [e, () => t({ editor: this.editor })])))), {
			plugins: t,
			inputRules: n
		});
	}
	getExtensions() {
		return new Map(this.extensions.map((e) => [e.key, e]));
	}
	getExtension(e) {
		if (typeof e == "string") return this.extensions.find((t) => t.key === e) || void 0;
		if (typeof e == "function") return this.extensionFactories.get(e) || void 0;
		throw Error(`Invalid extension type: ${typeof e}`);
	}
	hasExtension(e) {
		return typeof e == "string" ? this.extensions.some((t) => t.key === e) : typeof e == "object" && "key" in e ? this.extensions.some((t) => t.key === e.key) : typeof e == "function" ? this.extensionFactories.has(e) : !1;
	}
};
//#endregion
//#region src/util/expandToWords.ts
function hi(e, t) {
	let { $from: n, $to: r } = t;
	if (n.pos > n.start() && n.pos < e.content.size) {
		let t = e.textBetween(n.pos, n.pos + 1);
		if (/^[\w\p{P}]$/u.test(t)) {
			let t = e.textBetween(n.start(), n.pos).match(/[\w\p{P}]+$/u);
			t && (n = e.resolve(n.pos - t[0].length));
		}
	}
	if (r.pos < r.end() && r.pos > 0) {
		let t = e.textBetween(r.pos - 1, r.pos);
		if (/^[\w\p{P}]$/u.test(t)) {
			let t = e.textBetween(r.pos, r.end()).match(/^[\w\p{P}]+/u);
			t && (r = e.resolve(r.pos + t[0].length));
		}
	}
	return {
		$from: n,
		$to: r,
		from: n.pos,
		to: r.pos
	};
}
//#endregion
//#region src/api/blockManipulation/selections/selection.ts
function gi(e) {
	let t = _(e);
	if (e.selection.empty || "node" in e.selection) return;
	let n = e.doc.resolve(C(e.doc, e.selection.from).posBeforeNode), r = e.doc.resolve(C(e.doc, e.selection.to).posBeforeNode), i = (r, i) => {
		let a = n.posAtIndex(r, i), o = e.doc.resolve(a).nodeAfter;
		if (!o) throw Error(`Error getting selection - node not found at position ${a}`);
		return b(o, t);
	}, a = [], o = n.sharedDepth(r.pos), s = n.index(o), c = r.index(o);
	if (n.depth > o) {
		a.push(b(n.nodeAfter, t));
		for (let e = n.depth; e > o; e--) if (n.node(e).type.isInGroup("childContainer")) {
			let t = n.index(e) + 1, r = n.node(e).childCount;
			for (let n = t; n < r; n++) a.push(i(n, e));
		}
	} else a.push(i(s, o));
	for (let e = s + 1; e <= c; e++) a.push(i(e, o));
	if (a.length === 0) throw Error(`Error getting selection - selection doesn't span any blocks (${e.selection})`);
	return { blocks: a };
}
function _i(e, t, n) {
	let r = typeof t == "string" ? t : t.id, a = typeof n == "string" ? n : n.id, o = g(_(e));
	if (r === a) throw Error(`Attempting to set selection with the same anchor and head blocks (id ${r})`);
	let s = i(r, e.doc);
	if (!s) throw Error(`Block with ID ${r} not found`);
	let c = i(a, e.doc);
	if (!c) throw Error(`Block with ID ${a} not found`);
	let l = ie(s), u = ie(c), d = o.blockSchema[l.blockNoteType], f = o.blockSchema[u.blockNoteType];
	if (!l.isBlockContainer || d.content === "none") throw Error(`Attempting to set selection anchor in block without content (id ${r})`);
	if (!u.isBlockContainer || f.content === "none") throw Error(`Attempting to set selection anchor in block without content (id ${a})`);
	let p, m;
	if (d.content === "table") {
		let e = at.get(l.blockContent.node);
		p = l.blockContent.beforePos + e.positionAt(0, 0, l.blockContent.node) + 1 + 2;
	} else p = l.blockContent.beforePos + 1;
	if (f.content === "table") {
		let t = at.get(u.blockContent.node), n = u.blockContent.beforePos + t.positionAt(t.height - 1, t.width - 1, u.blockContent.node) + 1;
		m = n + e.doc.resolve(n).nodeAfter.nodeSize - 2;
	} else m = u.blockContent.afterPos - 1;
	e.setSelection(P.create(e.doc, p, m));
}
function vi(e, t = !1) {
	let n = _(e), r = t ? hi(e.doc, e.selection) : e.selection, i = r.$from, a = r.$to;
	for (; a.parentOffset >= a.parent.nodeSize - 2 && a.depth > 0;) a = e.doc.resolve(a.pos + 1);
	for (; a.parentOffset === 0 && a.depth > 0;) a = e.doc.resolve(a.pos - 1);
	for (; i.parentOffset === 0 && i.depth > 0;) i = e.doc.resolve(i.pos - 1);
	for (; i.parentOffset >= i.parent.nodeSize - 2 && i.depth > 0;) i = e.doc.resolve(i.pos + 1);
	let o = re(e.doc.slice(i.pos, a.pos, !0), n);
	return {
		_meta: {
			startPos: i.pos,
			endPos: a.pos
		},
		...o
	};
}
//#endregion
//#region src/editor/managers/SelectionManager.ts
var yi = class {
	constructor(e) {
		this.editor = e;
	}
	getSelection() {
		return this.editor.transact((e) => gi(e));
	}
	getSelectionCutBlocks(e = !1) {
		return this.editor.transact((t) => vi(t, e));
	}
	setSelection(e, t) {
		return this.editor.transact((n) => _i(n, e, t));
	}
	getTextCursorPosition() {
		return this.editor.transact((e) => Vn(e));
	}
	setTextCursorPosition(e, t = "start") {
		return this.editor.transact((n) => Hn(n, e, t));
	}
	getSelectionBoundingBox() {
		if (!this.editor.prosemirrorView) return;
		let { selection: e } = this.editor.prosemirrorState, { ranges: t } = e, n = Math.min(...t.map((e) => e.$from.pos)), r = Math.max(...t.map((e) => e.$to.pos));
		if ($e(e)) {
			let e = this.editor.prosemirrorView.nodeDOM(n);
			if (e) return e.getBoundingClientRect();
		}
		return nt(this.editor.prosemirrorView, n, r).toJSON();
	}
}, bi = class {
	constructor(e) {
		this.editor = e;
	}
	activeTransaction = null;
	can(e) {
		try {
			return this.isInCan = !0, e();
		} finally {
			this.isInCan = !1;
		}
	}
	isInCan = !1;
	exec(e) {
		if (this.activeTransaction) throw Error("`exec` should not be called within a `transact` call, move the `exec` call outside of the `transact` call");
		if (this.isInCan) return this.canExec(e);
		let t = this.prosemirrorState, n = this.prosemirrorView;
		return e(t, (e) => this.prosemirrorView.dispatch(e), n);
	}
	canExec(e) {
		if (this.activeTransaction) throw Error("`canExec` should not be called within a `transact` call, move the `canExec` call outside of the `transact` call");
		let t = this.prosemirrorState, n = this.prosemirrorView;
		return e(t, void 0, n);
	}
	transact(e) {
		if (this.activeTransaction) return e(this.activeTransaction);
		try {
			this.activeTransaction = this.editor._tiptapEditor.state.tr;
			let t = e(this.activeTransaction), n = this.activeTransaction;
			return this.activeTransaction = null, n && (n.docChanged || n.selectionSet || n.scrolledIntoView || n.storedMarksSet || !n.isGeneric) && this.prosemirrorView.dispatch(n), t;
		} finally {
			this.activeTransaction = null;
		}
	}
	get prosemirrorState() {
		if (this.activeTransaction) throw Error("`prosemirrorState` should not be called within a `transact` call, move the `prosemirrorState` call outside of the `transact` call or use `editor.transact` to read the current editor state");
		return this.editor._tiptapEditor.state;
	}
	get prosemirrorView() {
		return this.editor._tiptapEditor.view;
	}
	isFocused() {
		return this.prosemirrorView?.hasFocus() || !1;
	}
	focus() {
		this.prosemirrorView?.focus();
	}
	get isEditable() {
		if (!this.editor._tiptapEditor) {
			if (!this.editor.headless) throw Error("no editor, but also not headless?");
			return !1;
		}
		return this.editor._tiptapEditor.isEditable === void 0 ? !0 : this.editor._tiptapEditor.isEditable;
	}
	set isEditable(e) {
		if (!this.editor._tiptapEditor) {
			if (!this.editor.headless) throw Error("no editor, but also not headless?");
			return;
		}
		this.editor._tiptapEditor.options.editable !== e && this.editor._tiptapEditor.setEditable(e);
	}
	undo() {
		let e = this.editor.getExtension("yUndo");
		if (e) return this.exec(e.undoCommand);
		let t = this.editor.getExtension("history");
		if (t) return this.exec(t.undoCommand);
		throw Error("No undo plugin found");
	}
	redo() {
		let e = this.editor.getExtension("yUndo");
		if (e) return this.exec(e.redoCommand);
		let t = this.editor.getExtension("history");
		if (t) return this.exec(t.redoCommand);
		throw Error("No redo plugin found");
	}
};
//#endregion
//#region src/api/blockManipulation/insertContentAt.ts
function xi(e, t, n, r = { updateSelection: !0 }) {
	let { from: i, to: a } = typeof t == "number" ? {
		from: t,
		to: t
	} : {
		from: t.from,
		to: t.to
	}, o = !0, s = !0, c = "";
	if (n.forEach((e) => {
		e.check(), o && e.isText && e.marks.length === 0 ? c += e.text : o = !1, s = s ? e.isBlock : !1;
	}), i === a && s) {
		let { parent: t } = e.doc.resolve(i);
		t.isTextblock && !t.type.spec.code && !t.childCount && (--i, a += 1);
	}
	return o ? e.insertText(c, i, a) : e.replaceWith(i, a, n), r.updateSelection && rt(e, e.steps.length - 1, -1), !0;
}
//#endregion
//#region src/editor/managers/StyleManager.ts
var Si = class {
	constructor(e) {
		this.editor = e;
	}
	insertInlineContent(e, { updateSelection: t = !1 } = {}) {
		let n = x(e, this.editor.pmSchema);
		this.editor.transact((e) => {
			xi(e, {
				from: e.selection.from,
				to: e.selection.to
			}, n, { updateSelection: t });
		});
	}
	getActiveStyles() {
		return this.editor.transact((e) => {
			let t = {}, n = e.selection.$to.marks();
			for (let e of n) {
				let n = this.editor.schema.styleSchema[e.type.name];
				if (!n) {
					e.type.name !== "link" && !e.type.spec.blocknoteIgnore && console.warn("mark not found in styleschema", e.type.name);
					continue;
				}
				n.propSchema === "boolean" ? t[n.type] = !0 : t[n.type] = e.attrs.stringValue;
			}
			return t;
		});
	}
	addStyles(e) {
		for (let [t, n] of Object.entries(e)) {
			let e = this.editor.schema.styleSchema[t];
			if (!e) throw Error(`style ${t} not found in styleSchema`);
			if (e.propSchema === "boolean") this.editor._tiptapEditor.commands.setMark(t);
			else if (e.propSchema === "string") this.editor._tiptapEditor.commands.setMark(t, { stringValue: n });
			else throw new u(e.propSchema);
		}
	}
	removeStyles(e) {
		for (let t of Object.keys(e)) this.editor._tiptapEditor.commands.unsetMark(t);
	}
	toggleStyles(e) {
		for (let [t, n] of Object.entries(e)) {
			let e = this.editor.schema.styleSchema[t];
			if (!e) throw Error(`style ${t} not found in styleSchema`);
			if (e.propSchema === "boolean") this.editor._tiptapEditor.commands.toggleMark(t);
			else if (e.propSchema === "string") this.editor._tiptapEditor.commands.toggleMark(t, { stringValue: n });
			else throw new u(e.propSchema);
		}
	}
	getSelectedText() {
		return this.editor.transact((e) => e.doc.textBetween(e.selection.from, e.selection.to));
	}
	getLinkMarkAtPos(e) {
		return this.editor.transact((t) => {
			let n = t.doc.resolve(e), r = n.marks().find((e) => e.type.name === "link");
			if (!r) return;
			let i = Xe(n, r.type);
			if (i) return {
				href: r.attrs.href,
				from: i.from,
				to: i.to,
				text: t.doc.textBetween(i.from, i.to)
			};
		});
	}
	getSelectedLinkUrl() {
		return this.editor.transact((e) => this.getLinkMarkAtPos(e.selection.from)?.href);
	}
	createLink(e, t) {
		e !== "" && this.editor.transact((n) => {
			let { from: r, to: i } = n.selection, a = this.editor.pmSchema.mark("link", { href: e });
			t ? n.insertText(t, r, i).addMark(r, r + t.length, a) : n.addMark(r, i, a);
		});
	}
	editLink(e, t, n = this.editor.transact((e) => e.selection.anchor)) {
		this.editor.transact((r) => {
			let { from: i, to: a } = this.getLinkMarkAtPos(n + 1) || {
				from: r.selection.from,
				to: r.selection.to
			}, o = this.editor.pmSchema.mark("link", { href: e });
			t !== r.doc.textBetween(i, a) && r.insertText(t, i, a), r.addMark(i, i + t.length, o);
		}), this.editor.prosemirrorView.focus();
	}
	deleteLink(e = this.editor.transact((e) => e.selection.anchor)) {
		this.editor.transact((t) => {
			let { from: n, to: r } = this.getLinkMarkAtPos(e + 1) || {
				from: t.selection.from,
				to: t.selection.to
			};
			t.removeMark(n, r, this.editor.pmSchema.marks.link).setMeta("preventAutolink", !0);
		}), this.editor.prosemirrorView.focus();
	}
};
//#endregion
//#region src/editor/transformPasted.ts
function Ci(e) {
	return qe(e.state.selection.$from, (e) => e.type.name === "tableCell" || e.type.name === "tableHeader") !== void 0;
}
function wi(e, t) {
	let n = t.nodes.hardBreak, r = F.empty;
	return e.forEach((e) => {
		e.isTextblock && e.childCount > 0 ? (r = r.append(e.content), r = r.addToEnd(n.create())) : e.isText ? r = r.addToEnd(e) : e.isBlock && e.childCount > 0 && (r = r.append(wi(e.content, t)), r = r.addToEnd(n.create()));
	}), r.lastChild?.type === n && (r = r.cut(0, r.size - 1)), r;
}
function Ti(e, t) {
	let n = [];
	return e.forEach((e, r, i) => {
		i !== t && n.push(e);
	}), F.from(n);
}
function Ei(e, t) {
	let n = [];
	for (let r = 0; r < e.childCount; r++) if (e.child(r).type.name === "tableRow") if (n.length > 0 && n[n.length - 1].type.name === "table") {
		let t = n[n.length - 1], i = t.copy(t.content.addToEnd(e.child(r)));
		n[n.length - 1] = i;
	} else {
		let i = t.nodes.table.createChecked(void 0, e.child(r));
		n.push(i);
	}
	else n.push(e.child(r));
	return e = F.from(n), e;
}
function Di(e, t) {
	let n = F.from(e.content);
	if (n = Ei(n, t.state.schema), Ci(t)) {
		let e = !1;
		if (n.descendants((t) => {
			t.type.isInGroup("tableContent") && (e = !0);
		}), !e && !t.state.schema.nodes.tableParagraph.validContent(n)) return new it(wi(n, t.state.schema), 0, 0);
	}
	if (!Oi(n, t)) return new it(n, e.openStart, e.openEnd);
	for (let e = 0; e < n.childCount; e++) if (n.child(e).type.spec.group === "blockContent") {
		let r = [n.child(e)];
		if (e + 1 < n.childCount && n.child(e + 1).type.name === "blockGroup") {
			let t = n.child(e + 1).child(0).child(0);
			(t.type.name === "bulletListItem" || t.type.name === "numberedListItem" || t.type.name === "checkListItem") && (r.push(n.child(e + 1)), n = Ti(n, e + 1));
		}
		let i = t.state.schema.nodes.blockContainer.createChecked(void 0, r);
		n = n.replaceChild(e, i);
	}
	return new it(n, e.openStart, e.openEnd);
}
function Oi(e, t) {
	let n = e.childCount === 1, r = e.firstChild?.type.spec.content === "inline*", i = e.firstChild?.type.spec.content === "tableRow+";
	if (n) {
		if (r) return !1;
		if (i) {
			let e = y(t.state);
			if (e.isBlockContainer) return e.blockContent.node.type.spec.content !== "tableRow+";
		}
	}
	return !0;
}
//#endregion
//#region src/editor/BlockNoteEditor.ts
var ki = {
	enableInputRules: !0,
	enablePasteRules: !0,
	enableCoreExtensions: !1
}, Ai = class e extends Fe {
	pmSchema;
	_tiptapEditor;
	elementRenderer = null;
	blockCache = /* @__PURE__ */ new WeakMap();
	dictionary;
	schema;
	blockImplementations;
	inlineContentImplementations;
	styleImplementations;
	uploadFile;
	onUploadStartCallbacks = [];
	onUploadEndCallbacks = [];
	resolveFileUrl;
	settings;
	static create(t) {
		return new e(t ?? {});
	}
	constructor(e) {
		super(), this.options = e, this.dictionary = e.dictionary || Pe, this.settings = { tables: {
			splitCells: e?.tables?.splitCells ?? !1,
			cellBackgroundColor: e?.tables?.cellBackgroundColor ?? !1,
			cellTextColor: e?.tables?.cellTextColor ?? !1,
			headers: e?.tables?.headers ?? !1
		} };
		let t = {
			defaultStyles: !0,
			schema: e.schema || se.create(),
			...e,
			placeholders: {
				...this.dictionary.placeholders,
				...e.placeholders
			}
		};
		if (this.schema = t.schema, this.blockImplementations = t.schema.blockSpecs, this.inlineContentImplementations = t.schema.inlineContentSpecs, this.styleImplementations = t.schema.styleSpecs, t.uploadFile) {
			let e = t.uploadFile;
			this.uploadFile = async (t, n) => {
				this.onUploadStartCallbacks.forEach((e) => e.apply(this, [n]));
				try {
					return await e(t, n);
				} finally {
					this.onUploadEndCallbacks.forEach((e) => e.apply(this, [n]));
				}
			};
		}
		this.resolveFileUrl = t.resolveFileUrl, this._eventManager = new Gt(this), this._extensionManager = new mi(this, t);
		let n = this._extensionManager.getTiptapExtensions(), r = this._extensionManager.hasExtension("ySync") || this._extensionManager.hasExtension("liveblocksExtension");
		r && t.initialContent && console.warn("When using Collaboration, initialContent might cause conflicts, because changes should come from the collaboration provider");
		let i = {
			...ki,
			...t._tiptapOptions,
			element: null,
			autofocus: t.autofocus ?? !1,
			extensions: n,
			editorProps: {
				...t._tiptapOptions?.editorProps,
				attributes: {
					tabIndex: "0",
					...t._tiptapOptions?.editorProps?.attributes,
					...t.domAttributes?.editor,
					class: s("bn-editor", t.defaultStyles ? "bn-default-styles" : "", t.domAttributes?.editor?.class || "")
				},
				transformPasted: Di
			}
		};
		try {
			let e = t.initialContent || (r ? [{
				type: "paragraph",
				id: "initialBlockId"
			}] : [{
				type: "paragraph",
				id: o.options.generateID()
			}]);
			if (!Array.isArray(e) || e.length === 0) throw Error("initialContent must be a non-empty array of blocks, received: " + e);
			let n = Qe(i.extensions), a = Ge({
				type: "doc",
				content: [{
					type: "blockGroup",
					content: e.map((e) => c(e, n, this.schema.styleSchema).toJSON())
				}]
			}, n, i.parseOptions);
			this._tiptapEditor = new Ue({
				...i,
				content: a.toJSON()
			}), this.pmSchema = this._tiptapEditor.schema;
		} catch (e) {
			throw Error("Error creating document from blocks passed as `initialContent`", { cause: e });
		}
		let a, l = this.pmSchema.nodes.doc.createAndFill;
		this.pmSchema.nodes.doc.createAndFill = (...e) => {
			if (a) return a;
			let t = l.apply(this.pmSchema.nodes.doc, e), n = JSON.parse(JSON.stringify(t.toJSON()));
			return n.content[0].content[0].attrs.id = "initialBlockId", a = Re.fromJSON(this.pmSchema, n), a;
		}, this.pmSchema.cached.blockNoteEditor = this, this._tiptapEditor.on("mount", () => {
			this.headless = !1;
		}), this._tiptapEditor.on("unmount", () => {
			this.headless = !0;
		}), this._blockManager = new Wt(this), this._exportManager = new Bn(this), this._selectionManager = new yi(this), this._stateManager = new bi(this), this._styleManager = new Si(this), this.emit("create");
	}
	_blockManager;
	_eventManager;
	_exportManager;
	_extensionManager;
	_selectionManager;
	_stateManager;
	_styleManager;
	get extensions() {
		return this._extensionManager.getExtensions();
	}
	exec(e) {
		return this._stateManager.exec(e);
	}
	canExec(e) {
		return this._stateManager.canExec(e);
	}
	transact(e) {
		return this._stateManager.transact(e);
	}
	unregisterExtension = (...e) => this._extensionManager.unregisterExtension(...e);
	registerExtension = (...e) => this._extensionManager.registerExtension(...e);
	getExtension = ((...e) => this._extensionManager.getExtension(...e));
	mount = (e) => {
		let t = e.getRootNode();
		typeof ShadowRoot < "u" && t instanceof ShadowRoot ? t.appendChild(this.portalElement) : document.body.appendChild(this.portalElement), this._tiptapEditor.mount({ mount: e });
	};
	unmount = () => {
		this.portalElement?.remove(), this._tiptapEditor.unmount();
	};
	get prosemirrorState() {
		return this._stateManager.prosemirrorState;
	}
	get prosemirrorView() {
		return this._stateManager.prosemirrorView;
	}
	get domElement() {
		if (!this.headless) return this.prosemirrorView?.dom;
	}
	_portalElement;
	get portalElement() {
		if (typeof document > "u") throw Error("Portal element accessed, but not available in headless mode");
		return this._portalElement ||= document.createElement("div"), this._portalElement;
	}
	isWithinEditor = (e) => !!(this.domElement?.parentElement?.contains(e) || this.portalElement?.contains(e));
	isFocused() {
		return this.headless ? !1 : this.prosemirrorView?.hasFocus() || !1;
	}
	headless = !0;
	focus() {
		this.headless || this.prosemirrorView.focus();
	}
	blur() {
		this.headless || this.domElement?.blur();
	}
	onUploadStart(e) {
		return this.onUploadStartCallbacks.push(e), () => {
			let t = this.onUploadStartCallbacks.indexOf(e);
			t > -1 && this.onUploadStartCallbacks.splice(t, 1);
		};
	}
	onUploadEnd(e) {
		return this.onUploadEndCallbacks.push(e), () => {
			let t = this.onUploadEndCallbacks.indexOf(e);
			t > -1 && this.onUploadEndCallbacks.splice(t, 1);
		};
	}
	get topLevelBlocks() {
		return this.document;
	}
	get document() {
		return this._blockManager.document;
	}
	getBlock(e) {
		return this._blockManager.getBlock(e);
	}
	getPrevBlock(e) {
		return this._blockManager.getPrevBlock(e);
	}
	getNextBlock(e) {
		return this._blockManager.getNextBlock(e);
	}
	getParentBlock(e) {
		return this._blockManager.getParentBlock(e);
	}
	forEachBlock(e, t = !1) {
		this._blockManager.forEachBlock(e, t);
	}
	onEditorContentChange(e) {
		this._tiptapEditor.on("update", e);
	}
	onEditorSelectionChange(e) {
		this._tiptapEditor.on("selectionUpdate", e);
	}
	onBeforeChange(e) {
		return this._extensionManager.getExtension(fe).subscribe(e);
	}
	getTextCursorPosition() {
		return this._selectionManager.getTextCursorPosition();
	}
	setTextCursorPosition(e, t = "start") {
		return this._selectionManager.setTextCursorPosition(e, t);
	}
	getSelection() {
		return this._selectionManager.getSelection();
	}
	getSelectionCutBlocks(e = !1) {
		return this._selectionManager.getSelectionCutBlocks(e);
	}
	setSelection(e, t) {
		return this._selectionManager.setSelection(e, t);
	}
	get isEditable() {
		return this._stateManager.isEditable;
	}
	set isEditable(e) {
		this._stateManager.isEditable = e;
	}
	insertBlocks(e, t, n = "before") {
		return this._blockManager.insertBlocks(e, t, n);
	}
	updateBlock(e, t) {
		return this._blockManager.updateBlock(e, t);
	}
	removeBlocks(e) {
		return this._blockManager.removeBlocks(e);
	}
	replaceBlocks(e, t) {
		return this._blockManager.replaceBlocks(e, t);
	}
	undo() {
		return this._stateManager.undo();
	}
	redo() {
		return this._stateManager.redo();
	}
	insertInlineContent(e, { updateSelection: t = !1 } = {}) {
		this._styleManager.insertInlineContent(e, { updateSelection: t });
	}
	getActiveStyles() {
		return this._styleManager.getActiveStyles();
	}
	addStyles(e) {
		this._styleManager.addStyles(e);
	}
	removeStyles(e) {
		this._styleManager.removeStyles(e);
	}
	toggleStyles(e) {
		this._styleManager.toggleStyles(e);
	}
	getSelectedText() {
		return this._styleManager.getSelectedText();
	}
	getSelectedLinkUrl() {
		return this._styleManager.getSelectedLinkUrl();
	}
	createLink(e, t) {
		this._styleManager.createLink(e, t);
	}
	getLinkMarkAtPos(e) {
		return this._styleManager.getLinkMarkAtPos(e);
	}
	editLink(e, t, n) {
		this._styleManager.editLink(e, t, n);
	}
	deleteLink(e) {
		this._styleManager.deleteLink(e);
	}
	canNestBlock() {
		return this._blockManager.canNestBlock();
	}
	nestBlock() {
		this._blockManager.nestBlock();
	}
	canUnnestBlock() {
		return this._blockManager.canUnnestBlock();
	}
	unnestBlock() {
		this._blockManager.unnestBlock();
	}
	moveBlocksUp() {
		return this._blockManager.moveBlocksUp();
	}
	moveBlocksDown() {
		return this._blockManager.moveBlocksDown();
	}
	blocksToHTMLLossy(e = this.document) {
		return this._exportManager.blocksToHTMLLossy(e);
	}
	blocksToFullHTML(e = this.document) {
		return this._exportManager.blocksToFullHTML(e);
	}
	tryParseHTMLToBlocks(e) {
		return this._exportManager.tryParseHTMLToBlocks(e);
	}
	blocksToMarkdownLossy(e = this.document) {
		return this._exportManager.blocksToMarkdownLossy(e);
	}
	tryParseMarkdownToBlocks(e) {
		return this._exportManager.tryParseMarkdownToBlocks(e);
	}
	onChange(e, t) {
		return this._eventManager.onChange(e, t);
	}
	onSelectionChange(e, t) {
		return this._eventManager.onSelectionChange(e, t);
	}
	onMount(e) {
		return this._eventManager.onMount(e);
	}
	onUnmount(e) {
		return this._eventManager.onUnmount(e);
	}
	getSelectionBoundingBox() {
		return this._selectionManager.getSelectionBoundingBox();
	}
	get isEmpty() {
		let e = this.document;
		return e.length === 0 || e.length === 1 && e[0].type === "paragraph" && e[0].content.length === 0;
	}
	pasteHTML(e, t = !1) {
		this._exportManager.pasteHTML(e, t);
	}
	pasteText(e) {
		return this._exportManager.pasteText(e);
	}
	pasteMarkdown(e) {
		return this._exportManager.pasteMarkdown(e);
	}
}, ji = class {
	constructor(e, t, n) {
		this.mappings = t, this.options = n;
	}
	async resolveFile(e) {
		if (!this.options?.resolveFileUrl) return (await fetch(e)).blob();
		let t = await this.options.resolveFileUrl(e);
		return t instanceof Blob ? t : (await fetch(t)).blob();
	}
	mapStyles(e) {
		return Object.entries(e).map(([e, t]) => this.mappings.styleMapping[e](t, this));
	}
	mapInlineContent(e) {
		return this.mappings.inlineContentMapping[e.type](e, this);
	}
	transformInlineContent(e) {
		return e.map((e) => this.mapInlineContent(e));
	}
	async mapBlock(e, t, n, r) {
		return this.mappings.blockMapping[e.type](e, this, t, n, r);
	}
};
//#endregion
//#region src/exporter/mapping.ts
function Mi(e) {
	return {
		createBlockMapping: (e) => e,
		createInlineContentMapping: (e) => e,
		createStyleMapping: (e) => e
	};
}
//#endregion
//#region src/util/combineByGroup.ts
function Ni(e, ...t) {
	let n = [...e];
	for (let e of t) for (let t of e) {
		let e = n.findLastIndex((e) => e.group === t.group);
		e === -1 ? n.push(t) : n.splice(e + 1, 0, t);
	}
	return n;
}
//#endregion
export { z as _, hi as a, ft as b, Rn as c, Ht as d, Ut as f, B as g, V as h, Ai as i, W as l, Tt as m, Mi as n, Wr as o, Vt as p, ji as r, zn as s, Ni as t, Bt as u, mt as v, dt as x, pt as y };

//# sourceMappingURL=src-wdvzVmbO.js.map